



































































































































































































































































































































































































































































































































































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasPaginationTemplate from '../AmetrasPaginationTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import AmetrasAdvancedFilterTemplate from '@/views/AmetrasAdvancedFilterTemplate.vue';
import {
  DataProviderDataResponse,
  DATATABLE_SERVICE_INSTANCE,
  TableAccessConfig
} from '@/services/datatable/datatable.service';
import {HTML_SERVICE_INSTANCE} from '@/services/html.service';
import SubMenuTemplate from '@/views/SubMenuTemplate.vue';
import {URL_SERVICE_INSTANCE} from '@/services/url.service';
import {cloneDeep, filter, get, isEqual, matchesProperty, merge, set, throttle, toNumber} from 'lodash';
import {
  AdvancedFieldFunctionConfiguration
} from '@/fields/advanced-field-function-executor/advanced-field-function-configuration';
import {ExtendedDynamicComponentList} from '@/fields/advanced-field-function-executor/conditional-components.interface';
import {COLOR_SERVICE_INSTANCE, ColorService} from '@/services/style/color.service';
import AlertDialog from '@/views/AlertDialog.vue';
import PromtDialog from '@/views/PromtDialog.vue';
import {AxiosResponse} from 'axios';
import {ResizeSensor} from 'css-element-queries';
import AmetrasFormularWrapper from '@/views/AmetrasFormularWrapper.vue';
import AmetrasDynamicContentDialog from '@/views/AmetrasDynamicContentDialog.vue';
import AmetrasLabelTemplate from '@/fields/AmetrasLabelTemplate.vue';
import AmetrasDynamicFieldWithAdvancedFilterTemplate from '@/fields/AmetrasDynamicFieldWithAdvancedFilterTemplate.vue';
import DatatableHeaderWithSortingAndFiltering from '@/views/datatable/datatable-header-with-sorting-and-filtering.vue';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import {AMETRAS_PARAM_UTILS} from '@/utils/params.utils';
import {CompositeKeyType} from '@/interfaces/key.interface';
import ConditionalComponentRenderer from '@/fields/advanced-field-function-executor/ConditionalComponentRenderer.vue';
import {BreadCrumbConfig} from '../BreadcrumbTemplate.vue';
import {DisguiseRoute} from '@/routetype';
import {NAVI_SERVICE_INSTANCE} from '@/services/navi.service';
import DatatableResultRow from '@/views/datatable/datatable-result-row.vue';
import {DataTableItemProps} from 'vuetify';
import {
  DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE
} from '@/views/datatable/datatable-row-action-configuration-handler.service';
import {GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE} from '@/services/global-event-listener.service';
import ApexChartsTemplate from '@/views/datatable/ApexChartsTemplate.vue';
import AmetrasCustomPagiantionTemplate, {PaginationEvent} from '@/views/AmetrasCustomPaginationTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import {FONT_SERVICE_INSTANCE} from '@/services/style/font.service';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import {SUBJECT_UTILS_INSTANCE} from '@/utils/subject.utils';
import {ICONS_SERVICE_INSTANCE} from '@/utils/icons.service';
import Sortable, {SortableEvent} from 'sortablejs';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';
import {FIELD_EVENTS_INSTANCE} from '@/fields/field-events';
import {FormularCloseEventData} from '../formular/form.interface';
import FormTemplate from '@/views/formular/FormTemplate.vue';
// import {AUTOFILL_SERVICE_INSTANCE, AutofillFieldConfig} from '@/services/autofill.service';
import AdvancedConfirmDialog, {
  ConfirmationDialogButton,
  ConfirmationDialogConfig
} from '@/views/AdvancedConfirmDialog.vue';
import AmetrasDynamicContent from '@/views/AmetrasDynamicContent.vue';
import {
  CustomDTIconUrlRowDto,
  CustomDTRowDto,
  CustomDTTemplateDto,
  DatatableDialogType,
  DTSubMenuConfig,
  ExtendedCell,
  ExtendedFilterPreset,
  IndexedAndExtendedDTRowDto,
  IndexedRow,
  MouseOverMenuConfig,
  SubRowContext,
  SubRowsCacheEntry,
  SubRowsConfig
} from '@/views/datatable/datatable';
import DataTableCustomFilter from '@/views/datatable/DataTableCustomFilter.vue';
import DataTableCustomColumnConfig from '@/views/datatable/DataTableCustomColumnConfig.vue';
import DataTablePaginationSizeConfig from '@/views/datatable/DataTablePaginationSizeConfig.vue';
import DTEventDtoUnion = DisguiseDto.DTEventDtoUnion;

/**
 * Number of sub rows loaded when the configuration does not define a size.
 */
const SUB_ROWS_DEFAULT_SIZE = 100;

interface FormularConfig {
  '@type': 'FORMULAR';
  templateUrl: string;
  entityUrl: string;
  formTitle: string;
  create: boolean;
  primaryKey: CompositeKeyType;
  onClose: (formConfig: FormularConfig, eventData?: FormularCloseEventData) => void;
  onSave: (formConfig: FormularConfig, response: AxiosResponse) => void;
  overwrittenFields?: { [fieldName: string]: DisguiseDto.FTFieldDto };
}

@Component({
  name: 'data-table-template',
  components: {
    DataTablePaginationSizeConfig,
    DataTableCustomColumnConfig,
    AmetrasDynamicContent,
    AdvancedConfirmDialog,
    FormTemplate: () => import('@/views/formular/FormTemplate.vue'),
    ApexChartsTemplate,
    GraphTemplate: ApexChartsTemplate,
    AmetrasCheckBoxTemplate,
    AmetrasCustomPagiantionTemplate,
    DatatableResultRow,
    ConditionalComponentRenderer,
    DatatableHeaderWithSortingAndFiltering,
    AmetrasDynamicFieldWithAdvancedFilterTemplate,
    AmetrasLabelTemplate,
    AmetrasDynamicContentDialog,
    AmetrasFormularWrapper,
    AlertDialog,
    PromtDialog,
    SubMenuTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasAdvancedFilterTemplate,
    AmetrasTextFieldTemplate,
    AmetrasPaginationTemplate,
    AmetrasSelectFieldTemplate,
    DataTableCustomFilter
  }
})
export default class DataTableTemplate extends Vue {

  get theme() {
    return this.$vuetify.theme.dark;
  }

  @Prop({type: String, required: false, default: ''}) templateUrl!: string;
  @Prop({
    type: Object as () => CompositeKeyType,
    required: false,
    default: () => {
      return {};
    }
  }) contextParameter!: CompositeKeyType;
  @Prop({
    type: Object as () => DisguiseDto.DTInputConfigurationDto, required: false, default: () => {
      return {};
    }
  }) initInputConfiguration!: DisguiseDto.DTInputConfigurationDto; // contains the FULL search query
  /* Allows the selection of a single entry and returns the entry with all fields. */
  @Prop({required: false, default: false}) selectMode!: boolean;
  @Prop({required: false, default: false}) forceShow!: boolean;
  @Prop({
    default: ''
  }) marginDefinition!: string;
  @Prop({
    default: ''
  }) paddingDefinition!: string;
  @Prop({
    default: ''
  }) showTableTitle!: boolean;
  @Prop({
    default: ''
  }) toolbarMarginDefinition!: string;
  @Prop({type: Function})
  updateParent: any;
  @Prop({
    default: ''
  }) toolbarPaddingDefinition!: string;
  @Prop({
    default: null
  }) userRequestedReload!: BehaviorSubject<string> | null; // whenever a user requests a reload, e.g. by submenu tab
  @Prop({
    default: true
  }) reloadOnUserRequest!: boolean; // configuration whether the reload (e.g. by submenu click) will always refresh the content

  date = new Date().toISOString().substr(0, 10);
  fullTextSearchAutoFillNameAttribute = 'fulltextsearch'; // default

  // inline formular, e.g. for basic data formulars
  showInlineFormular: boolean = false;
  inlineFormularConfig: FormularConfig | null = null;

  // formular within dialog
  dialog: DatatableDialogType | null = null;
  showDialog: boolean = false;

  showRowMouseOverMenu: boolean = false;
  mouseOverMenuConfig: MouseOverMenuConfig | null = null;

  tableHasRowActions: boolean = false;
  tableHasSumRow: boolean = false;
  tableHasCreationRow: boolean = false;
  loading: boolean = false;
  actionWidth: number = 0;

  firstNonHiddenColIdx: number = 0; // first column idx that is not hidden

  input: Partial<CustomDTTemplateDto> = {
    search: {
      fullTextSearch: {
        active: false
      },
      columnBasedSearch: {}
    }
  };
  columnIndexMap: { [key: string]: DisguiseDto.DTColumnsDto } = {};

  maxSize: number = 0; // search provider controlled maxSize for a page
  totalPages: number = 0; // count of available pages for this search query
  // search provider controlled page for this search query. Will be reset if page is out of range.
  page: number = 0;

  inputConfigurationSubscriptionActive = false; // watch for changes of inputConfiguration active
  inputConfiguration: DisguiseDto.DTInputConfigurationDto = {}; // contains the FULL search query
  initialInputConfiguration: DisguiseDto.DTInputConfigurationDto = {}; // contains the FULL search query

  tableAccessConfig: TableAccessConfig | null = null; // holds the current search provider.

  subMenu: DTSubMenuConfig | null = null;

  creationRow: {
    rowIcons?: CustomDTIconUrlRowDto[];
    cells?: ExtendedCell[];
  } = {
    cells: []
  };
  creationRowValid: boolean = false; // indication whether the formular is valid and there is no field invalid
  dirty: boolean = true;
  lastSearchUsedForceLoad: boolean = false;

  dynamicComponents: ExtendedDynamicComponentList = {
    componentsByIdentifier: {}
  };
  creationRowAFFEConf: AdvancedFieldFunctionConfiguration | undefined;
  colorService: ColorService = COLOR_SERVICE_INSTANCE;
  iconsService = ICONS_SERVICE_INSTANCE;
  isOverflown: boolean = false; // if the table is overflown
  expandedRows: IndexedRow[] = [];
  uniqueRowCounter: number = 0;
  // sub rows of expanded rows, keyed by the unique row key. loaded the first time a row is expanded.
  subRowsCache: { [rowKey: number]: SubRowsCacheEntry } = {};

  confirmationDialogConfig: ConfirmationDialogConfig | null = null;

  // synchroner Re-Entry-Schutz gegen Doppelklick auf den Loesch-Bestaetigungs-Button. Wird im
  // onClick als ALLERERSTES geprueft und gesetzt und verhindert dadurch zuverlaessig einen zweiten
  // (parallelen) Request - unabhaengig davon, ob die reaktive Button-Sperre (loading/disabled)
  // rechtzeitig im DOM ankommt.
  private confirmActionPending: boolean = false;

  fontService = FONT_SERVICE_INSTANCE;

  $refs!: {
    creationRowForm: AmetrasFormularWrapper,
    alert: AlertDialog,
    promt: PromtDialog,
    inlineForm: FormTemplate,
    tableHeader: HTMLTableSectionElement,
    // unfortunately there is no exact type available.
    // See official doc: https://vuetifyjs.com/en/components/data-tables/
    table: any
  };

  rowOrderSaving: boolean = false;

  private pendingAFFERequestCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  private rowSortable: Sortable | null = null;
  private rowSortableHost: HTMLElement | null = null;
  private rowDragOriginalNextSibling: Node | null = null;
  private rowDragOriginalPreviousSibling: Element | null = null;

  private registeredGlobalEventListenerNames: string[] = [];

  private tableCreateAction: DisguiseDto.DTIconUrlTableDto | undefined;

  private userRequestedReloadSubscription: Subscription | undefined;
  private lastUserRequestedReloadReqId: string = '';
  private actionConfigModifyStore: { [referenceId: string]: any } = {};

  @Watch('inputConfiguration', {deep: true}) onInputConfigurationChanged(
      newValue: DisguiseDto.DTInputConfigurationDto,
      oldValue: DisguiseDto.DTInputConfigurationDto
  ) {
    if (
        this.inputConfigurationSubscriptionActive
        && !isEqual(newValue, oldValue)
    ) {
      this.loadData();
      this.$emit('inputConfigurationChange', this.inputConfiguration);
    }
  }

  @Watch('showInlineFormular') onFormOpenChanged(val: boolean) {
    if (!val) {
      this.$nextTick(() => {
        HTML_SERVICE_INSTANCE.focusFirstNode(this.$el);
      });
    }
  }

  @Watch('templateUrl') templateUrlChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      // reset old instance props
      this.tableAccessConfig = null;
      this.input = {
        search: {
          fullTextSearch: {
            active: false
          },
          columnBasedSearch: {}
        }
      };
      this.creationRow = {
        cells: []
      };
      this.loadData();
      this.fullTextSearchAutoFillNameAttribute = this.getTemplateUrlHtmlNameAttributeCapable();
    }
  }

  @Watch('userRequestedReload') userRequestedReloadChanged() {
    this.bindToReload();
  }

  selectColumnConfig(value: any) {
    this.inputConfiguration = {
      ...this.inputConfiguration,
      userPreferredColumnConfig: value
    };
    this.loadData();
  }

  selectFilterConfig(newValue: DisguiseDto.FilterConfigurationSelectionDto) {
    this.inputConfiguration = {
      ...this.inputConfiguration,
      page: 0,
      userPreferredCustomFilterConfig: newValue,
      searchValue: undefined
    };
  }

  /**
   * Once any filter at the top has been changedd
   * @param newInputConfiguration
   */
  onColumnConfigurationChange(newInputConfiguration: DisguiseDto.DTInputColumnDto[]) {
    this.inputConfiguration = {
      ...this.inputConfiguration,
      columns: newInputConfiguration,
      page: 0,
      userPreferredCustomFilterConfig: undefined
    };
  }

  /**
   * Once the fulltext search is changed
   */
  onFulltextSearchChanged(newValue: string) {
    this.inputConfiguration = {
      ...this.inputConfiguration,
      searchValue: newValue,
      page: 0,
      userPreferredCustomFilterConfig: undefined
    };
    /*AUTOFILL_SERVICE_INSTANCE.saveAutofillValues([{
      value: newValue,
      autofillName: this.fullTextSearchAutoFillNameAttribute
    }]);*/
  }

  onGlobalFilterValueChanged(newValue: string, globalFilterIndex: number) {
    if (this.inputConfiguration && this.inputConfiguration.globalFilters && this.inputConfiguration.globalFilters[globalFilterIndex]) {
      // by template definition, this if is always true
      // the build throws an error if this is not checked, thus we leave the if-check in

      const onChangeAction = this.inputConfiguration.globalFilters[globalFilterIndex].onChange;
      if (onChangeAction) {
        this.triggerGlobalFilterAction(onChangeAction, newValue);
      }

      const copyOfInputConfig = cloneDeep(this.inputConfiguration);
      if (copyOfInputConfig && copyOfInputConfig.globalFilters && copyOfInputConfig.globalFilters[globalFilterIndex]) {
        // this if is also due to builder shenanigans!
        copyOfInputConfig.globalFilters[globalFilterIndex].filterValue = newValue;
        this.inputConfiguration = {
          ...copyOfInputConfig,
          page: 0,
          userPreferredCustomFilterConfig: undefined
        };
      }
    }
  }

  triggerGlobalFilterAction(action: DisguiseDto.DTGlobalFilterAction, value: string) {
    if (action['@type'] === 'DTGlobalFilterOverrideMultipleColumnsAction') {
      const castOverrideAction = action as DisguiseDto.DTGlobalFilterOverrideMultipleColumnsAction;
      if (value === '' && castOverrideAction.clearIfEmpty) {
        for (const [index, colKey] of Object.entries(castOverrideAction.keyByValueIndex ?? {})) {
          for (const searchCol of (this.inputConfiguration.columns || [])) {
            if (searchCol.key === colKey) {
              searchCol.searchValue = '';
            }
          }
        }
      } else if (castOverrideAction.splitDelimiter) {
        // value is split by the delimiter and then evaluated
        const splitValues = value.split(castOverrideAction.splitDelimiter);
        for (const [index, colKey] of Object.entries(castOverrideAction.keyByValueIndex ?? {})) {
          // this cast is necessary, as the index is interpreted as a string after the typescript-generator plugin
          const castIndex = toNumber(index);

          for (const searchCol of (this.inputConfiguration.columns || [])) {
            if (searchCol.key === colKey) {
              searchCol.searchValue = splitValues[castIndex];
            }
          }
        }
      }
    }
  }

  rowClicked(rowProps: DataTableItemProps) {
    const selectIcon = this.findSelectIconInRow(rowProps.item);
    if (this.selectMode && selectIcon) {
      const url = this.buildRestURL(
          selectIcon.urlParameters || [],
          selectIcon.urlBase || '',
          rowProps.item,
          true
      );
      this.$emit('selected', {params: selectIcon.urlParameters, url, baseUrl: selectIcon.urlBase});
    }
  }

  /* Workaround for closing the menus without using v-model. */
  closeSubmenuDialog() {
    if (this.subMenu?.actionConfiguration) {
      for (const currentEvent of this.subMenu.actionConfiguration.events || []) {
        if (currentEvent.type === 'ReloadAfterCloseRedirectDto') {
          this.loadData();
        }
      }
    }
    if (this.subMenu && this.subMenu.actionConfiguration &&
        this.subMenu.actionConfiguration['@type'] === 'DTNOOPActionConfiguration') {
      this.subMenu = null;
    } else if (this.subMenu && this.subMenu.actionConfiguration &&
        this.subMenu.actionConfiguration['@type'] === 'DTOpenSubMenuConfiguration') {
      if (this.subMenu.actionConfiguration.reloadAfterClose) {
        this.subMenu = null;
        this.loadData();
      } else {
        this.subMenu = null;
      }
    } else {
      this.subMenu = null;
    }
  }

  created() {
    this.inputConfiguration = {
      selectMode: this.selectMode,
      filterColumns: this.getFilterColumnsFromContextParameter(),
      ...this.initInputConfiguration
    };
    this.loadData();
    this.fullTextSearchAutoFillNameAttribute = this.getTemplateUrlHtmlNameAttributeCapable();
  }

  mounted() {
    this.bindToReload();
  }

  destroyed() {
    this.unregisterAllGlobalEventListeners();
    this.destroyRowSortable();

    if (this.userRequestedReloadSubscription) {
      this.userRequestedReloadSubscription.unsubscribe();
    }
  }

  /**
   * The drag handle lives inside the action cell, so a table that only allows dragging still
   * needs the column.
   */
  get tableHasActionColumn(): boolean {
    return this.tableHasRowActions
        || !!this.creationRow.rowIcons
        || this.tableHasSumRow
        || this.rowDragEnabled;
  }

  /**
   * In select mode and with floating row actions there is no fixed action cell the handle could
   * live in, so dragging is off there.
   */
  get rowDragEnabled(): boolean {
    return !this.selectMode
        && this.input.floatingRowActions !== true
        && !!this.input.rowDragAndDrop;
  }

  /**
   * Dragging in a foreign sorting would let the user save an order he never saw, so it is only
   * allowed while the table stands in the maintained one.
   */
  get rowDragAllowedBySorting(): boolean {
    const settings = this.input.rowDragAndDrop;
    if (!settings || !settings.orderColumnKey) {
      return false;
    }
    for (const currentColumn of this.input.columns || []) {
      if (currentColumn.key === settings.orderColumnKey) {
        return currentColumn.sort === 'ASC' && currentColumn.sortRank === 0;
      }
    }
    return false;
  }

  get rowDragBlocked(): boolean {
    return !this.rowDragAllowedBySorting || this.rowOrderSaving;
  }

  /**
   * The tbody belongs to Vuetify because the table delivers its rows through v-slot:item, so the
   * Sortable instance is attached afterwards instead of using <draggable tag="tbody"> like the
   * column dialog does.
   */
  private syncRowSortable() {
    if (!this.rowDragEnabled) {
      this.destroyRowSortable();
      return;
    }
    const tableRef = this.$refs.table;
    // a chain of direct children, not a bare 'tbody': before the table sits the top slot with the
    // column dialog, which brings a tbody of its own through <draggable tag="tbody">.
    const tbody: HTMLElement | null = tableRef
        ? (tableRef.$el as HTMLElement)
            .querySelector<HTMLElement>(':scope > .v-data-table__wrapper > table > tbody')
        : null;
    if (!tbody) {
      // tslint:disable-next-line:no-console
      console.warn('tbody of the DataTable not found, row dragging stays off.');
      this.destroyRowSortable();
      return;
    }
    if (this.rowSortable && this.rowSortableHost === tbody) {
      this.rowSortable.option('disabled', this.rowDragBlocked);
      return;
    }
    this.destroyRowSortable();
    this.rowSortable = new Sortable(tbody, {
      handle: '.ametras-table-row__drag-handle',
      draggable: 'tr.ametras-table-row--draggable',
      ghostClass: 'ametras-table-row--ghost',
      dragClass: 'sortable-drag',
      fallbackTolerance: 5,
      disabled: this.rowDragBlocked,
      onStart: (event: SortableEvent) => {
        this.rowDragOriginalNextSibling = event.item.nextElementSibling;
        this.rowDragOriginalPreviousSibling = event.item.previousElementSibling;
      },
      onEnd: (event: SortableEvent) => {
        this.onRowDragEnd(event);
      }
    });
    this.rowSortableHost = tbody;
  }

  private destroyRowSortable() {
    if (this.rowSortable) {
      this.rowSortable.destroy();
      this.rowSortable = null;
    }
    this.rowSortableHost = null;
  }

  /**
   * Sortable moves the DOM node itself while Vue still knows the old order, so the node goes back
   * to its old place before the model is reordered.
   *
   * oldDraggableIndex/newDraggableIndex rather than oldIndex/newIndex: Sortable derives those two
   * through index(el, options.draggable) and counts only the previous siblings matching the
   * selector. Detail, sum, creation and spacer rows drop out that way, and counting siblings keeps
   * a nested table out. They are therefore exactly the indices in input.rows.
   */
  private onRowDragEnd(event: SortableEvent) {
    const oldRowIndex = event.oldDraggableIndex;
    const newRowIndex = event.newDraggableIndex;
    this.restoreDraggedRowPosition(event);

    if (oldRowIndex === undefined || newRowIndex === undefined || oldRowIndex === newRowIndex) {
      return;
    }
    const settings = this.input.rowDragAndDrop;
    if (!settings || !settings.orderEndpointUrl) {
      return;
    }
    const rowsInNewOrder = (this.input.rows || []).slice() as IndexedAndExtendedDTRowDto[];
    // if the model shrank during the drag, splice() would hand out undefined and the reported
    // order would carry a hole.
    if (oldRowIndex >= rowsInNewOrder.length || newRowIndex >= rowsInNewOrder.length) {
      return;
    }
    rowsInNewOrder.splice(newRowIndex, 0, rowsInNewOrder.splice(oldRowIndex, 1)[0]);
    // the row number drives the zebra stripes and the key of the expand section.
    for (let rowIndex = 0; rowIndex < rowsInNewOrder.length; rowIndex++) {
      rowsInNewOrder[rowIndex].index = rowIndex;
    }
    // the row stays where the user dropped it, no jumping back until the server answers.
    this.input.rows = rowsInNewOrder;
    this.saveRowOrder(settings, rowsInNewOrder);
  }

  /**
   * The successor alone is not enough: for the last row in the tbody it is null, and
   * insertBefore(..., null) appends to the end instead of restoring the old place. Hence the
   * fallback behind the remembered predecessor, and the front when there was neither.
   */
  private restoreDraggedRowPosition(event: SortableEvent) {
    if (this.rowDragOriginalNextSibling) {
      event.from.insertBefore(event.item, this.rowDragOriginalNextSibling);
    } else if (this.rowDragOriginalPreviousSibling) {
      this.rowDragOriginalPreviousSibling.insertAdjacentElement('afterend', event.item);
    } else {
      event.from.insertBefore(event.item, event.from.firstChild);
    }
    this.rowDragOriginalNextSibling = null;
    this.rowDragOriginalPreviousSibling = null;
  }

  /**
   * The reload is mandatory in the error case too, so that what is shown is the stored order
   * again.
   */
  private saveRowOrder(
      settings: DisguiseDto.DTRowDragAndDropSettingsDto,
      rowsInNewOrder: IndexedAndExtendedDTRowDto[]
  ) {
    this.rowOrderSaving = true;
    if (this.rowSortable) {
      this.rowSortable.option('disabled', true);
    }
    HTTP_SERVICE_INSTANCE.getAxios().put(settings.orderEndpointUrl || '', {
      orderedRowKeys: this.buildOrderedRowKeys(settings, rowsInNewOrder)
    } as DisguiseDto.DTRowOrderSaveDto).then(() => {
      if (settings.orderChangedSuccessMessage) {
        this.$store.commit('showSnack', {
          message: settings.orderChangedSuccessMessage,
          color: 'success'
        });
      }
      this.rowOrderSaving = false;
      // the lock is released here and not left to the reload: syncRowSortable() only runs once
      // loadData() gets an answer, so otherwise the button would be free and the Sortable
      // instance still locked.
      this.rowSortable?.option('disabled', this.rowDragBlocked);
      this.loadData();
    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: settings.orderChangedFailMessage || 'Datenaustausch fehlgeschlagen.',
          color: 'error'
        });
      }
      this.rowOrderSaving = false;
      this.rowSortable?.option('disabled', this.rowDragBlocked);
      this.loadData();
    });
  }

  /**
   * Hidden columns are explicitly allowed here and are the normal case: the server names the key
   * columns, and a hidden column carries a cell like any other.
   */
  private buildOrderedRowKeys(
      settings: DisguiseDto.DTRowDragAndDropSettingsDto,
      rowsInNewOrder: IndexedAndExtendedDTRowDto[]
  ): Array<{ [columnKey: string]: string }> {
    const columnIndexByKey: { [columnKey: string]: number } = {};
    for (const currentColumn of this.input.columns || []) {
      if (currentColumn.key !== undefined && currentColumn.columnIndex !== undefined) {
        columnIndexByKey[currentColumn.key] = currentColumn.columnIndex;
      }
    }

    const result: Array<{ [columnKey: string]: string }> = [];
    for (const currentRow of rowsInNewOrder) {
      const rowKey: { [columnKey: string]: string } = {};
      for (const currentColumnKey of settings.rowKeyColumnKeys || []) {
        const columnIndex = columnIndexByKey[currentColumnKey];
        const currentCell = columnIndex === undefined
            ? undefined
            : (currentRow.cells || [])[columnIndex];
        const cellValue = currentCell === undefined ? undefined : currentCell.value;
        rowKey[currentColumnKey] = cellValue === undefined || cellValue === null
            ? ''
            : String(cellValue);
      }
      result.push(rowKey);
    }
    return result;
  }

  loadData() {
    this.loading = true;

    this.lastSearchUsedForceLoad = this.inputConfiguration.forceLoad === true;

    if (!this.tableAccessConfig) {
      DATATABLE_SERVICE_INSTANCE.getTableConfig(
          this.templateUrl,
          this.inputConfiguration
      ).then((tableConfig) => {
        this.tableAccessConfig = tableConfig;
        this.loadInitialDataFromSearchProvider();
      }, (error) => {
        if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
          this.$store.commit('showSnack', {
            message: 'Datenabruf fehlgeschlagen.',
            color: 'error'
          });
        }
        this.loading = false;
      });
    } else {
      this.loadDataFromSearchProvider();
    }
  }

  loadInitialDataFromSearchProvider() {
    const response = this.tableAccessConfig?.searchProvider.getInitialData(
        this.inputConfiguration
    );
    if (response) {

      // initialise sort by initial API response
      this.handleSearchProviderResponse(response);

      // we assume that a complex action configuration disables prefetching
      if (this.tableCreateAction && !this.tableCreateAction.actionConfiguration) {
        this.inlineFormularConfig = {
          ['@type']: 'FORMULAR',
          create: true,
          entityUrl: this.getEntityUrl(this.tableCreateAction),
          formTitle: 'Hinzufügen',
          primaryKey: {},
          onSave: () => {
            this.closeInlineFormularAndReload();
          },
          onClose: () => {
            this.closeInlineFormular();
          },
          templateUrl: this.getTemplateUrl(this.tableCreateAction)
        };
      }

      this.$nextTick(() => {
        const tableRef = this.$refs.table;
        const tableHeaderRef = this.$refs.tableHeader;

        if (tableRef) {
          const throttledOverflowDetectionFnc = throttle(() => {
            if (tableRef.$el.clientWidth < tableHeaderRef.scrollWidth) {
              this.isOverflown = true;
            } else {
              this.isOverflown = false;
            }
          }, 200);
          const resizeSensor = new ResizeSensor(tableRef.$el, () => {
            throttledOverflowDetectionFnc();
          });
          throttledOverflowDetectionFnc();
        }

        if (this.input.initActions) {
          for (const initAction of this.input.initActions) {
            this.tableAction(initAction);
          }
        }
      });
    }
  }

  loadDataFromSearchProvider() {
    // field function configuration holds the affe instance. must be reset before each reload
    if (this.creationRowAFFEConf !== undefined) {
      this.creationRowAFFEConf.destroy();
      this.creationRowAFFEConf = undefined;
    }
    this.tableAccessConfig?.searchProvider.getData(this.inputConfiguration).then((response) => {

      // set filters
      if (this.inputConfiguration && this.inputConfiguration.columns && response.data.columns) {

        if (response.data.search && response.data.search.fullTextSearch) {
          this.inputConfiguration.searchValue = response.data.search.fullTextSearch.currentValue;
        }

        const responseColumnData: DisguiseDto.DTInputColumnDto[] = [];
        for (let columnIndex = 0; columnIndex < response.data.columns.length; columnIndex++) {
          const column = response.data.columns[columnIndex];
          responseColumnData[columnIndex] = {
            index: columnIndex,
            key: column.key,
            searchValue: (column.search || {}).currentValue,
            sort: column.sort,
            sortRank: column.sortRank
          };
        }

        this.inputConfiguration.columns = responseColumnData;
      }

      this.handleSearchProviderResponse(response);
      this.loading = false;
    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: 'Datenabruf fehlgeschlagen.',
          color: 'error'
        });
      }
      this.loading = false;
    });
  }

  enterPressed(rowIcon: DisguiseDto.DTIconUrlRowDto, creationRow: DisguiseDto.DTCreationRowDto) {
    if (creationRow.saveCreationRowWithEnter) {
      this.creationRowAction(rowIcon, creationRow);
    }
  }

  /**
   * Update the local values after search provider returned data
   */
  handleSearchProviderResponse(response: DataProviderDataResponse) {
    const start = Date.now();
    // 1. unregister all existing event listeners
    this.unregisterAllGlobalEventListeners();
    const eventListeners = response.data.globalEventListeners;
    if (eventListeners) {
      for (const currentGlobalEventListenerName of eventListeners) {
        // 2. register all
        this.registerGlobalEventListener(currentGlobalEventListenerName);
      }
    }

    const newExpandedRows: IndexedRow[] = [];
    this.input = {
      ...response.data,
      columns: ((columns: DisguiseDto.DTColumnsDto[]) => {
        for (let colIdx = 0; colIdx < (columns || []).length; colIdx++) {
          const currentColumn = (columns || [])[colIdx];
          if (!currentColumn.hidden) {
            this.firstNonHiddenColIdx = colIdx;
            break;
          }
        }
        return columns;
      })(response.data.columns || []),
      rows: ((rows: DisguiseDto.DTRowDto[],
              columns: DisguiseDto.DTColumnsDto[],
              expandedRows: IndexedRow[]) => {
        const result: IndexedAndExtendedDTRowDto[] = [];
        for (let rowIndex = 0; rowIndex < (rows || []).length; rowIndex++) {
          const currentRow = (rows || [])[rowIndex];
          const currentUniqueRowIndex = ++this.uniqueRowCounter;
          result.push({
            ...currentRow,
            index: rowIndex,
            key: currentUniqueRowIndex,
            primaryKey: this.getPrimaryKeyForRowItem(currentRow, columns)
          });
          if (currentRow.expanded) {
            expandedRows.push({
              index: rowIndex,
              key: currentUniqueRowIndex
            });
          }
        }
        return result;
      })(response.data.rows || [], response.data.columns || [], newExpandedRows),
      filterPresets: ((
          filterPresets: DisguiseDto.DTFilterPresetDto[],
          columns: DisguiseDto.DTColumnsDto[]
      ) => {
        const result: ExtendedFilterPreset[] = [];

        const inputConfigurationIndexedByKey: {
          [key: string]: DisguiseDto.DTColumnSearchDto | undefined
        } = {};
        for (const currentInputConfigurationColumn of columns || []) {
          if (currentInputConfigurationColumn.key) {
            inputConfigurationIndexedByKey[currentInputConfigurationColumn.key] = currentInputConfigurationColumn.search;
          }
        }

        for (const currentFilterPreset of filterPresets) {
          let filterPresetActive = true;

          for (const currentFilterConfig of currentFilterPreset.filter || []) {
            const columnSpecFound = inputConfigurationIndexedByKey[currentFilterConfig.key || ''];
            if (!columnSpecFound) {
              throw new Error(`Unknown Column key: ${currentFilterConfig.key}`);
            }
            if (currentFilterConfig.searchValue && currentFilterConfig.searchValue !== columnSpecFound.currentValue) {
              filterPresetActive = false;
              break;
            } else if (currentFilterConfig.searchValues && !isEqual(currentFilterConfig.searchValues, columnSpecFound.searchValues)) {
              filterPresetActive = false;
              break;
            }
          }

          result.push({
            ...currentFilterPreset,
            active: filterPresetActive
          });
        }

        return result;
      })(response.data.filterPresets || [], response.data.columns || [])
    };
    this.expandedRows = newExpandedRows;

    // the unique row keys change with every load, so old cache entries would never be hit again
    this.subRowsCache = {};
    for (const currentExpandedRow of newExpandedRows) {
      const initiallyExpandedRow = (this.input.rows || [])[currentExpandedRow.index];
      if (initiallyExpandedRow) {
        this.loadSubRows(initiallyExpandedRow as IndexedAndExtendedDTRowDto);
      }
    }

    // holds the model of the creation row.
    const clonedCreationRow = cloneDeep(response.data.creationRow);
    if (clonedCreationRow) {

      this.creationRow = {
        ...clonedCreationRow,
        cells: ((cells: DisguiseDto.DTCellDto[] | undefined) => {
          const result: ExtendedCell[] = [];
          for (const currentCell of cells || []) {
            result.push({
              ...currentCell,
              cellState: {
                value: currentCell.value,
                localErrorReasons: {},
                readonlyReasons: {},
                requiredReasons: {},
                loadingReasons: {},
                affeStyle: {}
              },
              remoteErrorReasons: {},
              component: DYNAMIC_FIELD_RESOLVER_INSTANCE.resolveComponent(
                  ((this.input.columns || [])[
                      currentCell.cellIndex === undefined ? -1 : currentCell.cellIndex
                      ] || {}).uiType,
                  (((this.input.columns || [])[
                      currentCell.cellIndex === undefined ? -1 : currentCell.cellIndex
                      ] || {}).dataType)
              ),
              fieldEventSubject: new Subject<{ eventName: string; eventArgs: any }>()
            });
          }
          return result;
        })(clonedCreationRow.cells)
      };

      if (this.input.creationRow?.advancedFieldFunctionConfiguration) {
        const affeConf = this.input.creationRow.advancedFieldFunctionConfiguration;
        const initialInit = this.creationRowAFFEConf === undefined;
        this.creationRowAFFEConf = new AdvancedFieldFunctionConfiguration(
            affeConf,
            this.dynamicComponents,
            this.changeContextParam,
            this.triggerConditionalComponentEvent,
            this.handleBusinessException,
            (count) => {
              this.pendingAFFERequestCount.next(count);
            }
        );
        // builds advanced field functions
        this.$nextTick(() => {
          if (this.creationRowAFFEConf) {
            // holds a O(1) fast accessible model map, contains
            // DTColumnDto.key as key and DTColumnDto as value
            if (this.input.columns) {
              for (const currentColumn of this.input.columns) {
                this.columnIndexMap[currentColumn.key || ''] = currentColumn;
              }
            }
            for (const currentFieldFunction of affeConf.advancedFieldFunctions || []) {
              // build new function executor
              const functionExecutor = this.creationRowAFFEConf.bindNewFieldFunctionExecutor(
                  currentFieldFunction
              );

              for (const currentFieldReferenceDescription
                  of currentFieldFunction.fieldReferenceDescriptions || []) {
                if (currentFieldReferenceDescription['@type'] === 'DTFieldReferenceDescription') {
                  const castedCurrentFieldReferenceDescription =
                      currentFieldReferenceDescription as
                          DisguiseDto.DTFieldReferenceDescription;
                  if (castedCurrentFieldReferenceDescription.key) {

                    const fieldRef =
                        this.lookupFieldReference(castedCurrentFieldReferenceDescription.key || '');

                    const modelIndex =
                        this.columnIndexMap[castedCurrentFieldReferenceDescription.key];
                    if (!modelIndex) {
                      throw new Error(
                          'Model value lookup for AdvancedFieldFunctionExecutor failed.'
                      );
                    }

                    if (modelIndex.columnIndex !== undefined && modelIndex.key !== undefined) {
                      const currentCell: ExtendedCell =
                          (this.creationRow?.cells || [])[modelIndex.columnIndex];
                      functionExecutor.bindNewFieldStateExecutor(
                          fieldRef,
                          currentFieldReferenceDescription,
                          currentCell.cellState,
                          currentCell.fieldEventSubject
                      );
                    } else {
                      throw new Error(
                          'Columnindex and ColumnKey must not be undefined.'
                      );
                    }
                  }
                }
              }
              for (const currentContextReferenceDescription
                  of currentFieldFunction.contextFieldReferenceDescriptions || []) {
                if (currentContextReferenceDescription.contextKeyPath) {
                  const contextParamValue =
                      this.contextParameter[currentContextReferenceDescription.contextKeyPath];
                  if (contextParamValue === undefined) {
                    throw new Error(
                        'context param value lookup for AdvancedFieldFunctionExecutor failed for keyPath: ' + currentContextReferenceDescription.contextKeyPath
                    );
                  }
                  functionExecutor.bindNewStaticContextField(
                      currentContextReferenceDescription,
                      contextParamValue
                  );
                }
              }
            }
            this.creationRowAFFEConf.afterInit();
            if (!initialInit) {
              this.creationRowAFFEConf.afterReInit();
            }
          }
        });

      }
    }

    this.input.creationRow ? this.tableHasCreationRow = true : this.tableHasCreationRow = false;
    this.maxSize = response.maxSize;
    this.totalPages = response.totalPages;
    this.page = response.page;
    if (!this.inputConfigurationSubscriptionActive) {
      this.inputConfiguration = {
        page: response.page,
        selectMode: this.selectMode,
        forceLoad: true,
        size: response.size,
        filterColumns: this.inputConfiguration.filterColumns,
        columns: ((inputColumns: DisguiseDto.DTColumnsDto[]) => {
          const result: DisguiseDto.DTInputColumnDto[] = [];
          if (inputColumns) {
            for (let columnIndex = 0; columnIndex < inputColumns.length; columnIndex++) {
              const column = inputColumns[columnIndex];
              result[columnIndex] = {
                index: columnIndex,
                key: column.key,
                searchValue: (column.search || {}).currentValue,
                sort: column.sort,
                sortRank: column.sortRank
              };
            }
          }
          return result;
        })(this.input.columns || []),
        searchValue: this.input.search?.fullTextSearch?.currentValue,
        globalFilters: (this.inputConfiguration.globalFilters || this.input.globalFilters)
      };
      this.initialInputConfiguration = cloneDeep(this.inputConfiguration);
      Vue.nextTick(() => {
        this.inputConfigurationSubscriptionActive = true;
      });
    } else {
      this.inputConfigurationSubscriptionActive = false;
      this.inputConfiguration.page = response.page;

      // once the server returned new data, we must sync the column config again.
      // if the user changed the column config, the column index might differ
      // in order to align indices, sort, and filter values, we build a map of all known old columns
      // if the old column is part of the new response, we update the old definition
      const oldColumnsIndexedByKey: { [key: string]: DisguiseDto.DTInputColumnDto } = {};
      for (const currentColumn of this.inputConfiguration.columns || []) {
        oldColumnsIndexedByKey[currentColumn.key || ''] = currentColumn;
      }
      for (const currentServerColumn of response.data.columns || []) {
        if (currentServerColumn.key) {
          const oldInputConfiguration = oldColumnsIndexedByKey[currentServerColumn.key];
          if (oldInputConfiguration) {
            oldInputConfiguration.index = currentServerColumn.columnIndex;
            oldInputConfiguration.sort = currentServerColumn.sort;
            oldInputConfiguration.sortRank = currentServerColumn.sortRank;
            if (currentServerColumn.search) {
              oldInputConfiguration.searchValue = currentServerColumn.search?.currentValue;
              oldInputConfiguration.searchValues = currentServerColumn.search?.searchValues;
            }
          }
        }
      }

      Vue.nextTick(() => {
        this.inputConfigurationSubscriptionActive = true;
      });
    }
    for (const currentIcon of this.input.tableIcons || []) {
      if (currentIcon.icon === 'ADD' || currentIcon.icon === 'ADDEQUIPMENT') {
        this.tableCreateAction = currentIcon;
        break;
      }
    }

    if (this.input) {
      if ((this.input.rows && this.input.rows[0] && (this.input.rows[0].rowIcons || this.input.rows[0].advancedButtons)) || this.creationRow.rowIcons?.length) {
        this.tableHasRowActions = true;
      }
      for (const currentSumRow of this.input.sumRows || []) {
        for (const currentSumRowCell of currentSumRow.cells || []) {
          if (currentSumRowCell !== null) {
            this.tableHasSumRow = true;
            break;
          }
        }
      }
    }

    this.focusShowIconIfSingleRow();

    this.loading = false;

    const endJS = Date.now();

    this.$nextTick(() => {

      // only now is the tbody rendered by Vuetify available.
      this.syncRowSortable();

      // tslint:disable-next-line:no-console
      console.log(`JS Execution time: ${endJS - start} ms`);
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.$nextTick(() => {
                this.$nextTick(() => {
                  this.$nextTick(() => {
                    this.$nextTick(() => {
                      this.$nextTick(() => {
                        this.$nextTick(() => {
                          this.$nextTick(() => {
                            this.$nextTick(() => {
                              this.$nextTick(() => {
                                this.$nextTick(() => {
                                  const end = Date.now();
                                  // tslint:disable-next-line:no-console
                                  console.log(`Rendering Execution time: ${end - start} ms`);
                                });
                              });
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  focusShowIconIfSingleRow() {
    Vue.nextTick(() => {
      if (this.input.rows?.length === 1) {
        const resultRow = (this.$refs as any)['result-row'];
        if (resultRow && resultRow.$refs) {
          const keys = [];
          for (const [key, value] of Object.entries(resultRow.$refs)) {
            if (/^row-icon/.test(key)) {
              keys.push({key: value});
            }
          }
          const vueComp = keys[0].key;
          if (Array.isArray(vueComp) && vueComp[0] instanceof Vue) {
            HTML_SERVICE_INSTANCE.focusFirstNode((vueComp[0] as Vue).$el);
          }
        }
      }
    });
  }

  /**
   * Defines the general entry method for all table actions.
   */
  tableAction(
      action: DisguiseDto.DTIconUrlTableDto
  ) {
    if (action.actionConfiguration &&
        (action.actionConfiguration['@type'] === 'DTFormDialogActionConfiguration'
            || action.actionConfiguration['@type'] === 'DTOpenInlineFormActionConfiguration'
            || action.actionConfiguration['@type'] === 'DTOpenHrefConfiguration'
        )
    ) {
      this.triggerActionWithConfiguration(action);
    } else {
      switch (action.icon) {
        case 'ADDEQUIPMENT':
        case 'ADD':
          this.inlineFormularConfig = {
            ['@type']: 'FORMULAR',
            create: true,
            entityUrl: this.input.entityUrl || '',
            formTitle: 'Hinzufügen',
            primaryKey: {},
            onSave: () => {
              this.closeInlineFormularAndReload();
            },
            onClose: () => {
              this.closeInlineFormular();
            },
            templateUrl: action.urlBase || ''
          };
          this.showInlineFormular = true;
          break;
        case 'ADD_DIALOG':
          this.showDialog = true;
          this.dialog = {
            dialogTitle: action.title || '',
            content: {
              ['@type']: 'FORMULAR',
              onClose: () => {
                this.closeDialog();
              },
              onSave: () => undefined,
              templateUrl: action.urlBase || '',
              entityUrl: this.input.entityUrl || '',
              primaryKey: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
              formTitle: action.title || '',
              create: false
            }
          };
          break;
        case 'SAVE':
          alert('save is not supported yet!');
          break;
        case 'EXPORTXLS':
          let apiURL: string = action.urlBase || '';
          const serializedInputConfig = URL_SERVICE_INSTANCE.serialize(this.inputConfiguration);
          const serializedFilterContext = URL_SERVICE_INSTANCE.serialize(this.contextParameter || {});
          if (serializedInputConfig) {
            apiURL += (apiURL.indexOf('?') > 0 ? '&' : '?') + serializedInputConfig;
          }
          if (serializedFilterContext) {
            apiURL += (apiURL.indexOf('?') > 0 ? '&' : '?') + serializedFilterContext;
          }
          window.open(apiURL, '_blank');
          break;
        default:
          break;
      }

    }

    if (action.actionConfiguration && action.actionConfiguration['@type'] === 'DTNOOPActionConfiguration') {
      if (action.actionConfiguration?.events) {
        for (const configuredEvent of action.actionConfiguration?.events) {
          if (configuredEvent.type === 'ReloadDTEventDto') {
            this.loadData();
          }
        }
      }
    }

  }

  /**
   * sperrt alle Buttons des aktuellen Bestaetigungs-Dialogs und zeigt am ausloesenden
   * Button einen Spinner. Die flache Neuzuweisung von confirmationDialogConfig erzwingt das
   * Re-Render des Dialogs - verschachtelte Button-Mutationen allein schlagen in Vue 2 hier nicht
   * zuverlaessig durch (deshalb war die urspruengliche Sperre wirkungslos). Reine UX-Anzeige; den
   * eigentlichen Doppelklick-Schutz uebernimmt das synchrone Flag confirmActionPending.
   */
  private lockConfirmationButtons(activeButton: ConfirmationDialogButton) {
    if (!this.confirmationDialogConfig) {
      return;
    }
    this.confirmationDialogConfig.buttons.forEach((b) => {
      b.disabled = true;
      b.loading = b === activeButton;
    });
    this.confirmationDialogConfig = {...this.confirmationDialogConfig};
  }

  onFieldValueChanged() {
    this.dirty = true;
  }

  buildFieldEventListenerMap(
      fieldDefinition: ExtendedCell
  ): any {
    return FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
      if (eventName === 'change') {
        fieldDefinition.cellState.value = eventArgs;
      }
      fieldDefinition.fieldEventSubject.next({
        eventName,
        eventArgs
      });
    });
  }

  buildRestURL(urlparameters: DisguiseDto.DTUrlParameterDto[] | undefined,
               urlbase: string,
               row: DisguiseDto.DTRowDto,
               overrideValues: boolean):
      string {
    let restURL = urlbase;
    const params: CompositeKeyType = this.getPrimaryKeyForRowItem(
        row,
        this.input.columns || [],
        urlparameters,
        overrideValues
    );
    restURL += (restURL.indexOf('?') > 0 ? '&' : '?') + URL_SERVICE_INSTANCE.serialize(params);
    return restURL;
  }

  /**
   * Defines the general entry method for all row actions.
   */
  rowMouseOverAction(event: MouseEvent,
                     el: HTMLElement,
                     action: CustomDTIconUrlRowDto) {
    let flyoutConfiguration: DisguiseDto.DTFlyoutActionConfiguration | undefined;
    if (action.actionConfiguration && action.actionConfiguration['@type'] === 'DTFlyoutActionConfiguration') {
      flyoutConfiguration = action.actionConfiguration;
    } else if (action.hoverActionConfiguration && action.hoverActionConfiguration['@type'] === 'DTFlyoutActionConfiguration') {
      flyoutConfiguration = action.hoverActionConfiguration;
    }

    if (flyoutConfiguration && flyoutConfiguration.content !== undefined) {
      this.mouseOverMenuConfig = {
        x: event.clientX + 15,
        y: event.clientY + 15,
        maxWidthInPx: flyoutConfiguration.maxWidthInPx || 1000,
        minWidthInPx: flyoutConfiguration.minWidthInPx || 200,
        title: flyoutConfiguration.flyoutTitle,
        content: flyoutConfiguration.content,
        primaryKey: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
        onClose: () => undefined,
        onSave: () => undefined,
      };
      this.showRowMouseOverMenu = true;
    }
  }


  /**
   * Defines the general entry method for all row actions.
   */
  rowMouseLeaveAction(event: MouseEvent,
                      el: HTMLElement,
                      action: CustomDTIconUrlRowDto) {
    if (action.actionConfiguration) {
      this.showRowMouseOverMenu = false;
      this.mouseOverMenuConfig = null;
    }
  }

  /**
   * Sub rows share the column grid of this table and are therefore rendered with the same result row component.
   * Vuetify only hands its slot props to the rows it renders itself, so they are built here. Expanding and
   * selecting are no-ops, because a sub row has no level below it.
   */
  buildSubRowItemProps(
      subRow: CustomDTRowDto,
      subRowIndex: number,
      headers: DisguiseDto.DTColumnsDto[]
  ): DataTableItemProps {
    return {
      item: {...subRow, index: subRowIndex},
      index: subRowIndex,
      expand: () => undefined,
      isExpanded: false,
      select: () => undefined,
      isSelected: false,
      headers
    } as unknown as DataTableItemProps;
  }

  /**
   * Row actions triggered from a sub row must not act on the rows of this table. The context tells the handler
   * which list it is working on.
   */
  buildSubRowContext(parentRow: IndexedAndExtendedDTRowDto): SubRowContext {
    return {
      reload: () => this.loadSubRows(parentRow, true)
    };
  }

  /**
   * Loads the sub rows of a row, the first time it is expanded or again on demand.
   */
  loadSubRows(row: IndexedAndExtendedDTRowDto, force: boolean = false) {
    const subRowsConfig: SubRowsConfig | undefined =
        (row as unknown as { subRows?: SubRowsConfig }).subRows;
    if (!subRowsConfig || !subRowsConfig.templateUrl) {
      return;
    }
    const existingEntry: SubRowsCacheEntry | undefined = this.subRowsCache[row.key];
    if (existingEntry && !force) {
      return;
    }
    const nextLoadCounter = (existingEntry ? existingEntry.loadCounter : 0) + 1;

    DATATABLE_SERVICE_INSTANCE.loadTable(subRowsConfig.templateUrl, {
      // the page index is zero based, page 1 would already be the second page and stay empty
      page: 0,
      size: subRowsConfig.size || SUB_ROWS_DEFAULT_SIZE
    }).then((response) => {
      this.$set(this.subRowsCache, row.key, {
        rows: response.data.rows || [],
        // the surrounding columns are the default, because cells and columns are matched by position
        input: subRowsConfig.inheritColumns === false ? response.data : this.input,
        loadCounter: nextLoadCounter
      } as SubRowsCacheEntry);
    }).catch((error) => {
      // keep an empty entry, otherwise the loading indicator would stay forever
      this.$set(this.subRowsCache, row.key, {
        rows: [],
        input: this.input,
        loadCounter: nextLoadCounter
      } as SubRowsCacheEntry);
      if (error && error.response) {
        this.handleBusinessException(error.response);
      }
    });
  }

  /**
   * Defines the general entry method for all row actions.
   */
  rowClickAction(rowClickEvent: Event,
                 action: DisguiseDto.DTIconUrlRowDto,
                 props: DataTableItemProps,
                 additionalUrlParams?: { [key: string]: string },
                 subRowContext?: SubRowContext) {
    rowClickEvent.stopPropagation(); // stop propagation to parents
    this.$set(action, 'loading', true);
    if (action.actionConfiguration && action.actionConfiguration['@type'] !== 'DTNOOPActionConfiguration') {
      if (action.actionConfiguration['@type'] === 'DTFormDialogActionConfiguration'
          || action.actionConfiguration['@type'] === 'DTOpenSubMenuConfiguration'
          || action.actionConfiguration['@type'] === 'DTBreadCrumbConfiguration'
          || action.actionConfiguration['@type'] === 'DTOpenInlineFormActionConfiguration'
          || action.actionConfiguration['@type'] === 'DTCallAPIAfterSelectConfiguration'
          || action.actionConfiguration['@type'] === 'DTSelectConfiguration'
      ) {
        this.triggerActionWithConfiguration(action, props.item);
      } else if (action.actionConfiguration['@type'] === 'DTExpandSectionActionConfiguration') {
        props.expand(!props.isExpanded);
        // isExpanded still holds the state before the toggle, so the row was just opened
        if (!props.isExpanded) {
          this.loadSubRows(props.item as IndexedAndExtendedDTRowDto);
        }
        this.$set(action, 'loading', false);
      } else if (action.actionConfiguration['@type'] === 'DTDialogCtrlActionConfiguration') {
        this.executeDialogCtrl(rowClickEvent, action, props, additionalUrlParams);
      } else if (action.actionConfiguration['@type'] === 'DTAdvancedDeleteActionConfiguration') {
        this.deleteItemFromTable(action, props, subRowContext);
      } else if (action.actionConfiguration['@type'] === 'DTPropagateEventActionConfiguration') {
        const keyForCurrentRow = this.getPrimaryKeyForRowItem(
            props.item,
            this.input.columns || [],
            action.urlParameters
        );
        if (action.actionConfiguration.eventName) {
          this.$emit(action.actionConfiguration.eventName, keyForCurrentRow);
        } else {
          throw new Error('Unknown Event name to emit.');
        }
        this.$set(action, 'loading', false);
      } else if (action.actionConfiguration['@type'] === 'DTOpenHrefConfiguration') {
        this.openHrefConfiguration(action, props.item);
      } else if (action.actionConfiguration['@type'] === 'DTCallApiConfiguration') {
        const castedActionConfiguration = action.actionConfiguration as DisguiseDto.DTCallApiConfiguration;

        const params: CompositeKeyType = this.getPrimaryKeyForRowItem(
            props.item,
            this.input.columns || [],
            action.urlParameters || [],
            true
        );
        if ('GET_NEW_TAB' === castedActionConfiguration.method) {
          window.open((castedActionConfiguration.href || '')
              + ((castedActionConfiguration.href || '').indexOf('?') > 0 ? '&' : '?')
              + URL_SERVICE_INSTANCE.serialize({
                ...additionalUrlParams,
                ...params,
              }), '_blank');
          for (const currentEvent of (action.actionConfiguration || {}).events || []) {
            if (currentEvent.type === 'ReloadDTEventDto') {
              this.loadData();
            }
            if (currentEvent.optionalUserMessage) {
              this.$store.commit('showSnack', {
                message: currentEvent.optionalUserMessage.text,
                color: 'success'
              });
            }
          }
          this.$set(action, 'loading', false);
        } else {
          HTTP_SERVICE_INSTANCE.getAxios().request({
            method: castedActionConfiguration.method || 'GET',
            url: castedActionConfiguration.href || '',
            params: {
              ...additionalUrlParams,
              ...params,
            }
          }).then(
              (response) => {
                for (const currentEvent of (action.actionConfiguration || {}).events || []) {
                  if (currentEvent.type === 'ReloadDTEventDto') {
                    this.loadData();
                  }

                  if (currentEvent.type === 'DTPropagateGlobalEventDto') {
                    const propagateEventData = currentEvent as DisguiseDto.DTPropagateGlobalEventDto;
                    DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE.propagateGlobalEvent(propagateEventData);
                  }

                  if (currentEvent.optionalUserMessage) {
                    this.$store.commit('showSnack', {
                      message: currentEvent.optionalUserMessage.text,
                      color: 'success'
                    });
                  }
                }
                this.$set(action, 'loading', false);
              }
          ).catch((error) => {
            if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
              if (error.response.data['@type'] === 'DisguiseBusinessExceptionConfirmationDialogDto') {
                const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionConfirmationDialogDto;

                const confirmDialogButtons: ConfirmationDialogButton[] = [];
                if (castedResponse.confirmButtonText) {
                  confirmDialogButtons.push({
                    text: castedResponse.confirmButtonText || '',
                    title: castedResponse.confirmButtonTitle || '',
                    disabled: false,
                    loading: false,
                    autoFocus: true,
                    onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
                      if (castedResponse.confirmButtonAction && castedResponse.confirmButtonAction['@type'] === 'ConfirmationDialogUrlAction') {
                        button.loading = true;
                        const confirmUrl = (castedResponse.confirmButtonAction as DisguiseDto.ConfirmationDialogUrlActionDto).url || '';
                        if (formularInstance) {
                          formularInstance.serializeFormularElementValues().then((formularParameters) => {
                            this.rowClickAction(
                                rowClickEvent,
                                {
                                  ...action,
                                  actionConfiguration: {
                                    '@type': 'DTCallApiConfiguration',
                                    'href': confirmUrl || '',
                                    'method': castedActionConfiguration.method,
                                    'events': castedActionConfiguration.events
                                  }
                                },
                                props,
                                {
                                  ...additionalUrlParams,
                                  ...formularParameters
                                }
                            );
                            this.confirmationDialogConfig = null;
                          });
                        } else {
                          this.rowClickAction(
                              rowClickEvent,
                              {
                                ...action,
                                actionConfiguration: {
                                  '@type': 'DTCallApiConfiguration',
                                  'href': confirmUrl || '',
                                  'method': castedActionConfiguration.method,
                                  'events': castedActionConfiguration.events
                                }
                              },
                              props,
                              additionalUrlParams
                          );
                          this.confirmationDialogConfig = null;
                        }
                      } else {
                        this.confirmationDialogConfig = null;
                      }
                    }
                  });
                }
                if (castedResponse.abortButtonText) {
                  confirmDialogButtons.push({
                    text: castedResponse.abortButtonText || '',
                    title: castedResponse.abortButtonTitle || '',
                    disabled: false,
                    loading: false,
                    onClick: () => {
                      this.confirmationDialogConfig = null;
                      this.$set(action, 'loading', false);
                    }
                  });
                }

                this.confirmationDialogConfig = {
                  title: castedResponse.title || '',
                  headerColor: 'primary',
                  message: castedResponse.message || '',
                  formular: castedResponse.formular,
                  buttons: confirmDialogButtons,
                  onEsc: () => {
                    this.confirmationDialogConfig = null;
                    this.$set(action, 'loading', false);
                  }
                };
              } else if (error.response.data['@type'] === 'DisguiseBusinessExceptionDialogDto') {
                const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionDialogDto;

                const dialogButtons: ConfirmationDialogButton[] = [];

                for (const responseButton of (castedResponse.buttons || [])) {
                  dialogButtons.push({
                    text: responseButton.text || '',
                    title: responseButton.title || '',
                    disabled: false,
                    loading: false,
                    autoFocus: responseButton.autoFocus || false,
                    onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
                      if (responseButton && responseButton.action && responseButton.action['@type'] === 'DisguiseDialogUrlAction') {
                        button.loading = true;
                        const confirmUrl = (responseButton.action as DisguiseDto.DisguiseDialogUrlActionDto).url || '';
                        if (formularInstance) {
                          formularInstance.serializeFormularElementValues().then((formularParameters) => {
                            this.rowClickAction(
                                rowClickEvent,
                                {
                                  ...action,
                                  actionConfiguration: {
                                    '@type': 'DTCallApiConfiguration',
                                    'href': confirmUrl || '',
                                    'method': castedActionConfiguration.method,
                                    'events': castedActionConfiguration.events
                                  }
                                },
                                props,
                                {
                                  ...additionalUrlParams,
                                  ...formularParameters
                                }
                            );
                            this.confirmationDialogConfig = null;
                          });
                        } else {
                          this.rowClickAction(
                              rowClickEvent,
                              {
                                ...action,
                                actionConfiguration: {
                                  '@type': 'DTCallApiConfiguration',
                                  'href': confirmUrl || '',
                                  'method': castedActionConfiguration.method,
                                  'events': castedActionConfiguration.events
                                }
                              },
                              props,
                              additionalUrlParams
                          );
                          this.confirmationDialogConfig = null;
                        }
                      } else {
                        this.confirmationDialogConfig = null;
                        this.$set(action, 'loading', false);
                      }
                    }
                  });
                }

                this.confirmationDialogConfig = {
                  title: castedResponse.title || '',
                  headerColor: 'primary',
                  message: castedResponse.message || '',
                  formular: castedResponse.formular,
                  buttons: dialogButtons,
                  onEsc: () => {
                    this.confirmationDialogConfig = null;
                    this.$set(action, 'loading', false);
                  }
                };
              } else {
                this.$store.commit('showSnack', {
                  message: 'Speichern fehlgeschlagen',
                  color: 'error'
                });
                this.$set(action, 'loading', false);
              }
            }
            this.$set(action, 'loading', false);
          });
        }
      } else if (action.actionConfiguration
          && action.actionConfiguration['@type'] === 'DTFlyoutActionConfiguration') {
        this.$set(action, 'loading', false);
        return;
      } else {
        DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE.triggerRowActionConfiguration(action.actionConfiguration);
        this.$set(action, 'loading', false);
      }
    } else {
      switch (action.icon) {
        case 'DELETE':
          this.deleteItemFromTable(action, props);
          break;
        case 'ADD_PURCHASEORDER':
        case 'COPY':
          this.inlineFormularConfig = {
            ['@type']: 'FORMULAR',
            create: true,
            entityUrl: this.input.entityUrl || '',
            formTitle: 'Hinzufügen',
            primaryKey: this.getPrimaryKeyForRowItem(
                props.item,
                this.input.columns || [],
                action.urlParameters
            ),
            onSave: () => {
              this.closeInlineFormularAndReload();
            },
            onClose: () => {
              this.closeInlineFormular();
            },
            templateUrl: action.urlBase || ''
          };
          this.showInlineFormular = true;
          this.$set(action, 'loading', false);
          break;
        case 'SHOW':
        case 'DOCUMENT_REVIEW':
        case 'LINK':
          if (this.input.rows) {
            if (action.actionType === 'SUBNAVI') {
              this.subMenu = {
                url: action.urlBase || '',
                contextParameter: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
                title: action.title || '',
                breadcrumbs: [],
                actionConfiguration: action.actionConfiguration
              };
              this.$set(action, 'loading', false);
            } else {
              this.inlineFormularConfig = {
                ['@type']: 'FORMULAR',
                create: false,
                entityUrl: this.input.entityUrl || '',
                formTitle: 'Bearbeiten',
                primaryKey: this.getPrimaryKeyForRowItem(
                    props.item,
                    this.input.columns || [],
                    action.urlParameters
                ),
                onSave: () => {
                  if (!action.actionConfiguration ||
                      action.actionConfiguration['@type'] !== 'DTNOOPActionConfiguration') {
                    this.closeInlineFormularAndReload();
                  }
                },
                onClose: (formConfig: FormularConfig, eventData?: FormularCloseEventData) => {
                  if (eventData && eventData.forceReload) {
                    this.closeInlineFormularAndReload();
                  } else {
                    this.closeInlineFormular();
                  }
                },
                templateUrl: this.input.formularUrl || action.urlBase || ''
              };
              this.showInlineFormular = true;
              this.$set(action, 'loading', false);
            }
          }
          break;
        case 'COPYDIALOG':
          this.showDialog = true;
          this.dialog = {
            content: {
              ['@type']: 'FORMULAR',
              create: true,
              formTitle: 'Kopieren',
              primaryKey: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
              onSave: (inlineFormularConfig: FormularConfig, response: AxiosResponse) => {
                this.closeDialog();
                if (response.status === 302) {
                  const castedResponse = response.data as DisguiseDto.RedirectDto;
                  if (castedResponse) {
                    if (castedResponse.optionalUserSuccessMessage) {
                      this.$store.commit('showSnack', {
                        message: castedResponse.optionalUserSuccessMessage,
                        color: 'success'
                      });
                    }
                    // 302 = MOVED PERMANENTLY
                    if (castedResponse.actionType && castedResponse.actionType['@type'] === 'SubMenuRedirectActionType') {
                      this.subMenu = {
                        url: castedResponse.actionType.url || '',
                        contextParameter: castedResponse.actionType.contextParameter,
                        title: '',
                        breadcrumbs: []
                      };
                    }
                  }
                }
              },
              entityUrl: this.input.entityUrl || '',
              templateUrl: action.urlBase || '',
              onClose: () => {
                this.closeDialog();
              },
            },
            dialogTitle: 'Kopieren'
          };
          this.$set(action, 'loading', false);
          break;
        case 'CHECKBOX_CHECKED':
        case 'CHECKBOX':
        case 'BOOKARROWLEFT':
        case 'SEND_EMAIL':
        case 'ACCEPTDATE':
        case 'CONFIRMBUTTON':
        case 'ADD_TO_PRINTERSELECTION':
          this.executeDialogCtrl(rowClickEvent, action, props, additionalUrlParams);
          break;
        case 'SELECT':
          this.triggerActionWithConfiguration(action, props.item);
          break;
        default:
          if (action.actionConfiguration
              && action.actionConfiguration['@type'] === 'DTNOOPActionConfiguration') {
            this.$set(action, 'loading', false);
          } else {
            this.todo();
            this.$set(action, 'loading', false);
          }
          break;
      }
    }
  }

  deleteItemFromTable(action: DisguiseDto.DTIconUrlRowDto,
                      props: DataTableItemProps,
                      subRowContext?: SubRowContext) {
    this.confirmationDialogConfig = {
      title: 'Bestätigen',
      headerColor: 'primary',
      message: 'Möchten Sie dieses Element löschen?',
      buttons: [{
        text: 'Bestätigen',
        title: 'Bestätigen',
        disabled: false,
        loading: false,
        autoFocus: true,
        onClick: (confirmButton: ConfirmationDialogButton) => {
          // zuverlaessiger Doppelklick-Schutz. Der synchrone Guard faengt einen zweiten
          // Klick sofort ab, auch wenn die reaktive Button-Sperre nicht durchschlaegt.
          if (this.confirmActionPending) {
            return;
          }
          this.confirmActionPending = true;
          this.lockConfirmationButtons(confirmButton);
          const restURL = this.buildRestURL(
              action.urlParameters || [],
              action.urlBase || '',
              props.item,
              action.icon !== 'DELETE'
          );
          HTTP_SERVICE_INSTANCE.getAxios().delete(restURL).then((response) => {
            if (subRowContext) {
              // the deleted row belongs to a sub row list, not to the rows of this table. splicing on
              // indexOf === -1 would drop the last row of the table instead.
              subRowContext.reload();
            } else if (this.input.rows) {
              const rowIndexToRemove = this.input.rows.indexOf(props.item);
              if (rowIndexToRemove >= 0) {
                this.input.rows.splice(rowIndexToRemove, 1);
              }
            }
            this.$store.commit('showSnack', {
              message: 'Löschen erfolgreich',
              color: 'success'
            });
            for (const currentEvent of (action.actionConfiguration || {}).events || []) {
              if (currentEvent.type === 'ReloadDTEventDto') {
                this.loadData();
              }
            }
            DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE.triggerRowActionConfiguration(action.actionConfiguration);
            this.$set(action, 'loading', false);
            this.confirmationDialogConfig = null;
          }, (error) => {
            if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
              if (error.response.data['@type'] === 'DisguiseBusinessExceptionConfirmationDialogDto') {
                const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionConfirmationDialogDto;

                const confirmDialogButtons: ConfirmationDialogButton[] = [];
                if (castedResponse.confirmButtonText) {
                  confirmDialogButtons.push({
                    text: castedResponse.confirmButtonText || '',
                    title: castedResponse.confirmButtonTitle || '',
                    disabled: false,
                    loading: false,
                    autoFocus: true,
                    onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
                      // derselbe synchrone Doppelklick-Schutz wie beim ersten Bestaetigungs-Dialog.
                      // Dieser Folge-Dialog (Business-Exception-Rueckfrage, z.B. beim Maschine-Loeschen) loest
                      // den EIGENTLICHEN Loesch-Request aus und war bisher ungesichert (nur button.loading, das
                      // in Vue 2 nicht zuverlaessig durchschlaegt) -> Button blieb mehrfach klickbar.
                      if (this.confirmActionPending) {
                        return;
                      }
                      if (castedResponse.confirmButtonAction && castedResponse.confirmButtonAction['@type'] === 'ConfirmationDialogUrlAction') {
                        this.confirmActionPending = true;
                        this.lockConfirmationButtons(button);
                        const confirmUrl = (castedResponse.confirmButtonAction as DisguiseDto.ConfirmationDialogUrlActionDto).url || '';
                        HTTP_SERVICE_INSTANCE.getAxios().delete(confirmUrl).then((response) => {
                          this.$store.commit('showSnack', {
                            message: 'Löschen erfolgreich',
                            color: 'success'
                          });
                          this.loadData();
                          this.confirmationDialogConfig = null;
                        }, (error) => {
                          this.$store.commit('showSnack', {
                            message: 'Löschen fehlgeschlagen',
                            color: 'error'
                          });
                          this.confirmationDialogConfig = null;
                        }).finally(() => {
                          this.confirmActionPending = false;
                        });
                      } else {
                        this.confirmationDialogConfig = null;
                      }
                    }
                  });
                }
                if (castedResponse.abortButtonText) {
                  confirmDialogButtons.push({
                    text: castedResponse.abortButtonText || '',
                    title: castedResponse.abortButtonTitle || '',
                    disabled: false,
                    loading: false,
                    onClick: () => {
                      this.confirmationDialogConfig = null;
                      this.$set(action, 'loading', false);
                    }
                  });
                }

                this.confirmationDialogConfig = {
                  title: castedResponse.title || '',
                  headerColor: 'primary',
                  message: castedResponse.message || '',
                  buttons: confirmDialogButtons,
                  formular: castedResponse.formular,
                  onEsc: () => {
                    this.confirmationDialogConfig = null;
                    this.$set(action, 'loading', false);
                  }
                };
              } else {
                this.$store.commit('showSnack', {
                  message: 'Löschen fehlgeschlagen',
                  color: 'error'
                });
                this.confirmationDialogConfig = null;
              }
            } else {
              this.confirmationDialogConfig = null;
            }
            this.$set(action, 'loading', false);
          }).finally(() => {
            this.confirmActionPending = false;
          });
        }
      }, {
        text: 'Abbrechen',
        title: 'Abbrechen',
        disabled: false,
        loading: false,
        onClick: () => {
          this.$set(action, 'loading', false);
          this.confirmationDialogConfig = null;
        }
      }],
      onEsc: () => {
        this.$set(action, 'loading', false);
        this.confirmationDialogConfig = null;
      }
    };
  }

  getBackgroundStyleFromPriorityList(
      backgroundColorPriority: DisguiseDto.EnumColor[]
  ) {
    let result = '';
    for (const currentBackgroundColorEntry of backgroundColorPriority || []) {
      if (currentBackgroundColorEntry) {
        result = this.colorService.getColor(
            currentBackgroundColorEntry,
            'BACKGROUND',
            this.$vuetify.theme.dark,
            true
        );
        break;
      }
    }
    return result;
  }

  getFontStyleFromPriorityList(
      fontWeightPriority: DisguiseDto.EnumFontWeight[]
  ) {
    let result = '';

    for (const currentFontWeightEntry of fontWeightPriority || []) {
      if (currentFontWeightEntry) {
        result = this.fontService.getFontWeight(currentFontWeightEntry);
        break;
      }
    }
    return result;
  }

  openSubNavi(response: DisguiseDto.RedirectDto) {
    this.closeDialog();
    const castedResponse = response as DisguiseDto.RedirectDto;
    if (castedResponse.actionType && castedResponse.actionType['@type'] === 'SubMenuRedirectActionType') {
      if ((castedResponse.actionType.openInParentDepthIdx || 0) > 1) {
        castedResponse.actionType.openInParentDepthIdx = (castedResponse.actionType.openInParentDepthIdx || 0) - 1;
        this.$emit('subnaviinparent', castedResponse);
      } else {
        this.subMenu = {
          url: castedResponse.actionType.url || '',
          contextParameter: castedResponse.actionType.contextParameter,
          title: '',
          breadcrumbs: [],
          actionConfiguration: castedResponse.actionType
        };
      }
    }
  }

  handleConfirmButtonResponse(response: any) {
    if (response.status < 400 && response.status !== 302) {
      if (response.data.successMessage) {
        this.$store.commit('showSnack', {
          message: response.data.successMessage,
          color: 'success'
        });
      }
    }
  }

  /**
   * Defines the general entry method for all creation row actions
   */
  creationRowAction(
      action: CustomDTIconUrlRowDto,
      creationRow: DisguiseDto.DTCreationRowDto
  ) {
    this.$set(action, 'loading', true);
    this.removeServerSidedErrorMessage();
    this.$nextTick(() => {
      // wait until AFFE created the necessary requests by waiting for next tick

      SUBJECT_UTILS_INSTANCE.delayUntilSubjectMatchesFilterConditionOnce(
          this.pendingAFFERequestCount,
          (currentCount) => currentCount === 0,
          () => {
            this.$nextTick(() => {
              this.$nextTick(() => {
                // wait until AFFE updated the data based on results by waiting for next tick
                this.dirty = this.$refs.creationRowForm.validate() && this.creationRowValid;
                if (this.creationRowValid) {
                  switch (action.icon) {
                    case 'SAVE': {
                      this.create(action, creationRow);
                      if (this.updateParent) {
                        this.updateParent();
                      }
                      break;
                    }
                    default:
                      this.todo();
                      this.$set(action, 'loading', false);
                      break;
                  }
                } else {
                  this.$store.commit('showSnack', {
                    message: 'Bitte korrigieren Sie alle rot markierten Felder',
                    color: 'warn'
                  });
                  this.$set(action, 'loading', false);
                }
              });
            });
          },
          () => {
            this.$set(action, 'loading', false);
            // any further error is already handled within the corresponding request.
          }
      );
    });
  }

  /* Placeholder method */
  todo() {
    alert('TODO');
  }

  closeInlineFormular() {
    if (this.showInlineFormular) {
      this.showInlineFormular = false;
    }
  }

  closeInlineFormularAndReload() {
    this.closeInlineFormular();
    this.loadData();
  }

  closeDialog() {
    this.dialog = null;
    this.showDialog = false;
  }

  closeDialogAndReload() {
    this.closeDialog();
    this.loadData();
  }

  /**
   * Change propagation of context params
   */
  changeContextParam(patchableContextParams: CompositeKeyType) {
    this.$emit('update-context-parameter', patchableContextParams);
  }

  triggerConditionalComponentEvent(
      nativeActionConfiguration: DisguiseDto.INativeEventConfigurationUnion,
      eventData: any
  ) {
    if (nativeActionConfiguration) {
      if (nativeActionConfiguration['@type'] === 'OpenFormularDTEventDto') {
        const castedNativeOpenFormularConfiguration =
            nativeActionConfiguration as DisguiseDto.OpenFormularDTEventDto;
        this.loadData();
        if (eventData) {
          this.inlineFormularConfig = {
            ['@type']: 'FORMULAR',
            create: false,
            entityUrl: this.input.entityUrl || '',
            formTitle: castedNativeOpenFormularConfiguration.title || '',
            primaryKey: eventData,
            onSave: () => {
              this.closeInlineFormularAndReload();
            },
            onClose: (formConfig: FormularConfig,
                      closeEventData?: FormularCloseEventData) => {
              if (closeEventData && closeEventData.forceReload) {
                this.closeInlineFormularAndReload();
              } else {
                this.closeInlineFormular();
              }
            },
            templateUrl: castedNativeOpenFormularConfiguration.formularUrl || ''
          };
          this.showInlineFormular = true;
        }
      } else if (nativeActionConfiguration['@type'] === 'ReloadDTEventDto') {
        this.loadData();
      } else {
        throw new Error('Unsupported native action configuration');
      }
    }
  }

  handleBusinessException(errorResponse: AxiosResponse) {
    return;
  }

  /**
   * Handles the page change event after user changed the page using pagination
   */
  pageChanged(paginationEvent: PaginationEvent) {
    this.inputConfiguration = {
      ...this.inputConfiguration,
      page: paginationEvent.page,
      forceLastPage: paginationEvent.forceLastPage
    };
  }

  cellButtonClicked(key: string, button: DisguiseDto.DTCellIconDto, event: MouseEvent) {
    const fieldReference = this.lookupFieldReference(key);
    if (fieldReference === undefined) {
      throw new Error('Unknown field reference');
    }
    if (button.prepend) {
      fieldReference.$emit('click:prepend', event);
    } else if (button.prependOuter) {
      fieldReference.$emit('click:prepend-outer', event);
    } else if (button.append) {
      fieldReference.$emit('click:append', event);
    } else if (button.appendOuter) {
      fieldReference.$emit('click:append-outer', event);
    }
  }

  activateFilterPreset(filterPreset: ExtendedFilterPreset) {
    if (filterPreset.filter) {
      const inputConfigurationIndexedByKey: { [key: string]: DisguiseDto.DTInputColumnDto } = {};
      for (const currentInputConfigurationColumn of cloneDeep(this.inputConfiguration.columns || [])) {
        if (currentInputConfigurationColumn.key) {
          inputConfigurationIndexedByKey[currentInputConfigurationColumn.key] = currentInputConfigurationColumn;
        }
      }

      for (const currentFilterPreset of this.input.filterPresets || []) {
        if (currentFilterPreset !== filterPreset) {
          currentFilterPreset.active = false;
        }
      }

      if (!filterPreset.active) {
        filterPreset.active = true;
        for (const currentFilter of filterPreset.filter) {
          const columnSpecFound = inputConfigurationIndexedByKey[currentFilter.key || ''];
          if (!columnSpecFound) {
            throw new Error(`Unknown Column key: ${currentFilter.key}`);
          }
          if (currentFilter.searchValue) {
            columnSpecFound.searchValue = currentFilter.searchValue;
          } else {
            delete columnSpecFound.searchValue;
          }
          if (currentFilter.searchValues) {
            columnSpecFound.searchValues = currentFilter.searchValues;
          } else {
            delete columnSpecFound.searchValues;
          }
        }
      } else {
        filterPreset.active = false;
        for (const currentFilter of filterPreset.filter) {
          const columnSpecFound = inputConfigurationIndexedByKey[currentFilter.key || ''];
          if (!columnSpecFound) {
            throw new Error(`Unknown Column key: ${currentFilter.key}`);
          }
          if (currentFilter.searchValue) {
            delete columnSpecFound.searchValue;
          } else if (currentFilter.searchValues) {
            delete columnSpecFound.searchValues;
          }
        }
      }

      this.inputConfiguration = {
        ...this.inputConfiguration,
        columns: Object.values(inputConfigurationIndexedByKey)
      };
    }
  }

  private bindToReload() {
    if (this.userRequestedReloadSubscription) {
      this.userRequestedReloadSubscription.unsubscribe();
    }
    if (this.userRequestedReload) {
      this.userRequestedReloadSubscription = this.userRequestedReload.subscribe((reqId) => {
        if (this.tableAccessConfig) { // ever loaded data, otherwise: nothing needs to be refreshed
          if (this.reloadOnUserRequest && this.lastUserRequestedReloadReqId !== reqId) {
            this.lastUserRequestedReloadReqId = reqId;
            this.inlineFormularConfig = null;

            /*
             if the user requested a reload, we want to reset all filters to the default filter values
             the reset depends on the dt configuration:
              - if we have a filter configuration, we take the current active one
              - if we don't have a filter configuration, we take the initial server response and modify page and size
             */
            if (this.input.customFilterConfig && this.input.customFilterConfig) {
              // we have any active filter configuration
              this.inputConfiguration = {
                ...this.inputConfiguration,
                userPreferredCustomFilterConfig: this.input.customFilterConfig.activeConfig
              };
            } else {
              // we don't have an active configuration
              this.inputConfiguration = {
                ...this.initialInputConfiguration, // the input configuration that has been returned by api during initial load
                page: 0, // reset page
                size: this.maxSize || 10, // take current size
                forceLoad: true // override forceload again
              };
            }
            this.closeInlineFormular();
            this.loadData();
          }
        }
      });
    }
  }

  private buildApiCallParametersForCreation(cells: ExtendedCell[],
                                            action: DisguiseDto.DTIconUrlRowDto) {
    let params: CompositeKeyType = {};
    if (action.customParameterConfiguration === undefined) {
      params = this.getPrimaryKeyForCreationCells(
          cells,
          this.input.columns || []
      );

      if (this.creationRowAFFEConf && action.icon) {
        const operationParameters = this.creationRowAFFEConf.getOperationParameters(action.icon);
        merge(params, operationParameters);
      }
    } else {
      for (const currentCustomParam of action.customParameterConfiguration.customParameters || []) {
        if (currentCustomParam.parameter !== undefined && currentCustomParam.value !== undefined) {
          params[currentCustomParam.parameter] = currentCustomParam.value;
        }
      }
      if (action.customParameterConfiguration.parametersByContextKey !== undefined) {
        for (const currentContextParamKey of Object.keys(action.customParameterConfiguration.parametersByContextKey || [])) {
          const currentContextParamEntry = action.customParameterConfiguration.parametersByContextKey[currentContextParamKey];
          if (currentContextParamEntry !== undefined && currentContextParamEntry.endpointKeyPath !== undefined) {
            let contextParamValue = this.contextParameter[currentContextParamKey];
            if (contextParamValue === undefined) {
              contextParamValue = currentContextParamEntry.defaultValue;
            }
            params[currentContextParamEntry.endpointKeyPath] = contextParamValue;
          }
        }
      }
      if (action.customParameterConfiguration.parametersByCellKey !== undefined) {
        for (const currentCellParamKey of Object.keys(action.customParameterConfiguration.parametersByCellKey || [])) {
          const currentCellParamEntry = action.customParameterConfiguration.parametersByCellKey[currentCellParamKey];
          if (currentCellParamEntry !== undefined && currentCellParamEntry.endpointKeyPath !== undefined) {
            let idx = -1;
            for (const currentColumn of this.input.columns || []) {
              if (currentColumn.key === currentCellParamKey) {
                idx = currentColumn.columnIndex || -1;
                break;
              }
            }
            if (idx >= 0 && cells && cells[idx] && cells[idx].cellState.value !== undefined) {
              params[currentCellParamEntry.endpointKeyPath] = cells[idx].cellState.value;
            } else {
              params[currentCellParamEntry.endpointKeyPath] = currentCellParamEntry.defaultValue;
            }
          }
        }
      }
    }

    return params;
  }

  private create(
      action: CustomDTIconUrlRowDto,
      creationRowDto: DisguiseDto.DTCreationRowDto,
      additionalUrlParams?: { [key: string]: string }
  ) {
    if (!this.input.submitWithBody) {
      this.todo();
      this.$set(action, 'loading', false);
    } else {
      if (!this.creationRow.cells) {
        throw new Error('No Creationrow defined!');
      }

      // save using body
      let hasClientErrors: boolean = false;

      for (const currentCreationRowCell of this.creationRow.cells || []) {
        hasClientErrors = Object.values(currentCreationRowCell.cellState.localErrorReasons).length > 0;
        if (hasClientErrors) {
          break;
        }
      }

      const actionUrlParams = {};
      for (const currentActionParameter of action.urlParameters || []) {
        set(actionUrlParams, currentActionParameter.parameter || '', currentActionParameter.value);
      }
      const actionUrlBase = action.urlBase || '';

      let submitUrl: string;
      const urlParams = URL_SERVICE_INSTANCE.serialize({
        ...actionUrlParams,
        ...(hasClientErrors ? {hasClientErrors} : {}),
        ...(additionalUrlParams ? additionalUrlParams : {}),
        ...(this.contextParameter ? this.contextParameter : {})
      });
      if (urlParams) {
        submitUrl = actionUrlBase
            + (actionUrlBase.indexOf('?') > -1 ? '&' : '?')
            + urlParams;
      } else {
        submitUrl = actionUrlBase;
      }

      const params: CompositeKeyType =
          this.buildApiCallParametersForCreation(this.creationRow.cells, action);

      HTTP_SERVICE_INSTANCE.getAxios().post(submitUrl, params).then((response) => {
        this.removeServerSidedErrorMessage();

        if (response.data.dialogParameterDto) {
          if (!response.data.dialogParameterDto.done) {
            switch (response.data.dialogParameterDto.dialogType) {
              case 'PROMT_DIALOG':
                this.$refs.promt.open('Achtung',
                    response.data.dialogParameterDto.dialogMessage).then(
                    (input: string) => {
                      const configuredId = response.data.dialogParameterDto.dialogConfirmedId;

                      this.create(action, creationRowDto, {
                        ...(input ? {promtInput: input} : {}),
                        ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                      });
                    });
                break;
              case 'ALERT_DIALOG':
                (this.$refs.alert as any).open('Achtung',
                    [response.data.dialogParameterDto.dialogMessage]).then(() => {
                  const configuredId = response.data.dialogParameterDto.dialogConfirmedId;
                  this.create(action, creationRowDto, {
                    ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                  });
                });
                break;
              case 'CONFIRM_DIALOG':
                this.confirmationDialogConfig = {
                  title: 'Bestätigen',
                  headerColor: 'primary',
                  message: response.data.dialogParameterDto.dialogMessage || '',
                  closeButton: {
                    onClick: () => {
                      this.$set(action, 'loading', false);
                      this.confirmationDialogConfig = null;
                    }
                  },
                  buttons: [{
                    text: response.data.confirmButtonTitle || 'Bestätigen',
                    title: response.data.confirmButtonTitle || 'Bestätigen',
                    disabled: false,
                    loading: false,
                    autoFocus: true,
                    onClick: () => {
                      const configuredId = response.data.dialogParameterDto.dialogConfirmedId;
                      this.create(action, creationRowDto, {
                        ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                      });
                      this.confirmationDialogConfig = null;
                    }
                  }, {
                    text: response.data.abortButtonTitle || 'Abbrechen',
                    title: response.data.abortButtonTitle || 'Abbrechen',
                    disabled: false,
                    loading: false,
                    onClick: () => {
                      const configuredId = response.data.dialogParameterDto.dialogAbortId;
                      this.create(action, creationRowDto, {
                        ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                      });
                      this.confirmationDialogConfig = null;
                    }
                  }],
                  onEsc: () => {
                    this.$set(action, 'loading', false);
                    this.confirmationDialogConfig = null;
                  }
                };
                break;
              default:
                break;
            }
          } else {
            this.$set(action, 'loading', false);
          }

          if (response.data.dialogParameterDto.openDialogAfterSuccess) {
            this.showDialog = true;
            this.dialog = {
              dialogTitle: response.data.dialogParameterDto.dialogTitle || '',
              content: {
                ['@type']: 'FORMULAR',
                onClose: () => {
                  this.closeDialog();
                },
                onSave: () => undefined,
                templateUrl: response.data.dialogParameterDto.dialogTemplateUrl || '',
                entityUrl: '',
                formTitle: response.data.dialogParameterDto.dialogTitle || '',
                create: false,
                primaryKey: {}
              }
            };
          }

          if (response.data.dialogParameterDto.success) {
            this.afterCreationRowSuccessfullySaved(action);
            this.loadData();
            this.$set(action, 'loading', false);
          }

        } else {
          this.afterCreationRowSuccessfullySaved(action);
          this.loadData();
          this.$set(action, 'loading', false);
        }
      }, (error) => {
        if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
          if (error.response && error.response.data && error.response.data['@type'] === 'DTValidationResultDto') {
            this.removeServerSidedErrorMessage();
            const castedResponse = error.response.data as DisguiseDto.DTValidationResultDto;
            if (error.response.status === 400) {
              if (castedResponse.validationEntries && this.creationRow.cells) {
                const combinedErrors = [];
                for (const remoteErrorDescription of castedResponse.validationEntries) {
                  if (remoteErrorDescription.key) {
                    const index = this.columnIndexMap[remoteErrorDescription.key].columnIndex;
                    if (index && index >= 0) {
                      const currentCell = this.creationRow.cells[index];
                      currentCell.remoteErrorReasons[remoteErrorDescription.validationMessage || ''] =
                          remoteErrorDescription.validationMessage || '';

                      if (remoteErrorDescription.newValue !== undefined) {
                        currentCell.cellState.value = remoteErrorDescription.newValue;
                      }

                      const allErrors = Object.values(currentCell.cellState.localErrorReasons)
                          .concat(Object.values(currentCell.remoteErrorReasons));

                      for (error of allErrors) {
                        combinedErrors.push(error);
                      }
                    }
                  }
                }
                if (combinedErrors.length > 0) {
                  this.$refs.alert.open('Achtung', combinedErrors).then(() => {
                    this.$nextTick(() => {
                      this.setFocusToFirstError();
                    });
                  });
                }
              }
              this.$set(action, 'loading', false);
            } else {
              this.$store.commit('showSnack', {
                message: 'Speichern fehlgeschlagen',
                color: 'error'
              });
              this.$set(action, 'loading', false);
            }
          } else if (error.response.data['@type'] === 'DisguiseBusinessExceptionConfirmationDialogDto') {
            const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionConfirmationDialogDto;

            const confirmDialogButtons: ConfirmationDialogButton[] = [];
            if (castedResponse.confirmButtonText) {
              confirmDialogButtons.push({
                text: castedResponse.confirmButtonText || '',
                title: castedResponse.confirmButtonTitle || '',
                disabled: false,
                loading: false,
                autoFocus: true,
                onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
                  if (castedResponse.confirmButtonAction && castedResponse.confirmButtonAction['@type'] === 'ConfirmationDialogUrlAction') {
                    const confirmUrl = (castedResponse.confirmButtonAction as DisguiseDto.ConfirmationDialogUrlActionDto).url || '';
                    button.loading = true;
                    if (formularInstance) {
                      formularInstance.serializeFormularElementValues().then((formularParameters) => {
                        this.create({
                              ...action,
                              urlBase: confirmUrl
                            },
                            creationRowDto,
                            {
                              ...additionalUrlParams,
                              ...formularParameters
                            }
                        );
                        this.confirmationDialogConfig = null;
                      });
                    } else {
                      this.create({
                            ...action,
                            urlBase: confirmUrl
                          },
                          creationRowDto,
                          additionalUrlParams
                      );
                      this.confirmationDialogConfig = null;
                    }
                  } else {
                    this.confirmationDialogConfig = null;
                  }
                }
              });
            }
            if (castedResponse.abortButtonText) {
              confirmDialogButtons.push({
                text: castedResponse.abortButtonText || '',
                title: castedResponse.abortButtonTitle || '',
                disabled: false,
                loading: false,
                onClick: () => {
                  this.confirmationDialogConfig = null;
                  this.$set(action, 'loading', false);
                }
              });
            }

            this.confirmationDialogConfig = {
              title: castedResponse.title || '',
              headerColor: 'primary',
              message: castedResponse.message || '',
              buttons: confirmDialogButtons,
              formular: castedResponse.formular,
              onEsc: () => {
                this.confirmationDialogConfig = null;
                this.$set(action, 'loading', false);
              }
            };
          } else if (error.response.data['@type'] === 'DisguiseBusinessExceptionDialogDto') {
            const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionDialogDto;

            const dialogButtons: ConfirmationDialogButton[] = [];
            for (const responseButton of (castedResponse.buttons || [])) {
              dialogButtons.push({
                text: responseButton.text || '',
                title: responseButton.title || '',
                disabled: false,
                loading: false,
                autoFocus: responseButton.autoFocus || false,
                onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
                  if (responseButton && responseButton.action  && responseButton.action['@type'] === 'DisguiseDialogUrlAction') {
                    const confirmUrl = (responseButton.action as DisguiseDto.DisguiseDialogUrlActionDto).url || '';
                    button.loading = true;
                    if (formularInstance) {
                      formularInstance.serializeFormularElementValues().then((formularParameters) => {
                        this.create({
                              ...action,
                              urlBase: confirmUrl
                            },
                            creationRowDto,
                            {
                              ...additionalUrlParams,
                              ...formularParameters
                            }
                        );
                        this.confirmationDialogConfig = null;
                      });
                    } else {
                      this.create({
                            ...action,
                            urlBase: confirmUrl
                          },
                          creationRowDto,
                          additionalUrlParams
                      );
                      this.confirmationDialogConfig = null;
                    }
                  } else {
                    this.confirmationDialogConfig = null;
                    this.$set(action, 'loading', false);
                  }
                }
              });
            }

            this.confirmationDialogConfig = {
              title: castedResponse.title || '',
              headerColor: 'primary',
              message: castedResponse.message || '',
              buttons: dialogButtons,
              formular: castedResponse.formular,
              onEsc: () => {
                this.confirmationDialogConfig = null;
                this.$set(action, 'loading', false);
              }
            };
          } else  {
            this.$store.commit('showSnack', {
              message: 'Speichern fehlgeschlagen',
              color: 'error'
            });
            this.$set(action, 'loading', false);
          }
        } else {
          this.$set(action, 'loading', false);
        }
      });

    }
  }

  private setFocusToFirstError() {
    if (this.creationRow.cells && this.input.columns) {
      for (let currentCellIdx = 0; currentCellIdx < this.creationRow.cells.length; currentCellIdx++) {
        const currentCell = this.creationRow.cells[currentCellIdx];
        const currentFieldLocalErrors = currentCell.cellState.localErrorReasons;
        const currentFieldRemoteErrors = currentCell.remoteErrorReasons;
        if (Object.values(currentFieldLocalErrors).concat(Object.keys(currentFieldRemoteErrors)).length > 0) {
          const fieldReferenceDescription: DisguiseDto.DTFieldReferenceDescription = {
            ['@type']: 'DTFieldReferenceDescription',
            key: this.input.columns[currentCellIdx].key
          };

          const fieldRef = this.lookupFieldReference(fieldReferenceDescription.key || '');
          HTML_SERVICE_INSTANCE.focusFirstNode(fieldRef.$el);
          break;
        }
      }
    }
  }

  private removeServerSidedErrorMessage() {
    for (const currentCell of this.creationRow.cells || []) {
      currentCell.remoteErrorReasons = {};
    }
  }

  private afterCreationRowSuccessfullySaved(
      action: CustomDTIconUrlRowDto
  ) {

    // Temporary disabled: creationrow and autofill doesnt work together if affe does something.
    /*    // save current values manually to autocomplete
        const autofillFields: AutofillFieldConfig[] = [];
        for (let currentCreationRowCellIdx = 0; currentCreationRowCellIdx < (this.creationRow.cells || []).length; currentCreationRowCellIdx++) {
          const currentCreationRowCell = (this.creationRow.cells || [])[currentCreationRowCellIdx];
          const currentColumn = (this.input.columns || [])[currentCreationRowCellIdx];
          if (currentColumn.autofillName !== undefined && currentCreationRowCell.cellState.value !== undefined) {
            autofillFields.push({
              autofillName: currentColumn.autofillName,
              value: currentCreationRowCell.cellState.value
            });
          }
        }
        AUTOFILL_SERVICE_INSTANCE.saveAutofillValues(autofillFields);*/

    this.$store.commit('showSnack', {
      message: 'Speichern erfolgreich',
      color: 'success'
    });
    DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE.triggerRowActionConfiguration(
        action.actionConfiguration,
        this.inputConfiguration
    );
  }

  private findSelectIconInRow(row: DisguiseDto.DTRowDto) {
    let selectIcon;
    for (const currentRowIcon of row.rowIcons || []) {
      if (currentRowIcon.icon === 'SELECT') {
        selectIcon = currentRowIcon;
        break;
      }
    }
    return selectIcon;
  }

  private getFilterColumnsFromContextParameter() {
    const result: DisguiseDto.DTInputColumnDto[] = [];

    for (const currentContextParameterName of Object.keys(this.contextParameter)) {
      result.push({
        key: currentContextParameterName,
        searchValues: [{
          equal: this.contextParameter[currentContextParameterName],
          relationalOperator: 'EQUALS'
        }]
      });
    }

    return result;
  }

  private lookupFieldReference(
      key: string,
      rowIndex: number = -1
  ): Vue {
    const fieldRefRaw = (this.$refs as any)[
    (key + (rowIndex > -1 ? `-${rowIndex}` : '')) || ''
        ];
    let fieldRef = fieldRefRaw;
    if (Array.isArray(fieldRefRaw)) {
      // if the reference points to multiple els, take the first
      fieldRef = fieldRefRaw[0];
    }
    return fieldRef as Vue;
  }

  private getPrimaryKeyForRowItem(
      row: DisguiseDto.DTRowDto | DisguiseDto.DTCreationRowDto,
      columns: DisguiseDto.DTColumnsDto[],
      params?: DisguiseDto.DTUrlParameterDto[],
      overrideValues?: boolean
  ): CompositeKeyType {
    let editKey: CompositeKeyType = {};
    if (params) {
      if (overrideValues) {
        const urlParamClone = [...params];
        for (const element of urlParamClone) {
          (columns || []).forEach((col) => {
            if (col.key === element.parameter && col.columnIndex !== undefined && row.cells) {
              element.value = row.cells[col.columnIndex].value;
              element.parameter = col.dtoPath ? col.dtoPath : (element.parameter || '');
            }
          });
        }
        editKey = AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(urlParamClone);
      } else {
        editKey = AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(params);
      }
    } else if (row.cells) {
      // stupid way: bind all cell values
      for (let i = 0; i < row.cells.length; i++) {
        const cell = row.cells[i];
        if (columns && columns[i]) {
          set(editKey, columns[i].dtoPath || columns[i].key || '', cell.value || '');
        }
      }
    }

    return editKey;
  }

  private getPrimaryKeyForCreationCells(
      cells: ExtendedCell[],
      columns: DisguiseDto.DTColumnsDto[],
      params?: DisguiseDto.DTUrlParameterDto[],
      overrideValues?: boolean
  ): CompositeKeyType {
    let editKey: CompositeKeyType = {};
    if (params) {
      if (overrideValues) {
        const urlParamClone = [...params];
        for (const element of urlParamClone) {
          (columns || []).forEach((col) => {
            if (col.key === element.parameter && col.columnIndex !== undefined && cells) {
              element.value = cells[col.columnIndex].cellState.value;
              element.parameter = col.dtoPath ? col.dtoPath : (element.parameter !== undefined ? element.parameter : '');
            }
          });
        }
        editKey = AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(urlParamClone);
      } else {
        editKey = AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(params);
      }
    } else if (cells) {
      // stupid way: bind all cell values
      for (let i = 0; i < cells.length; i++) {
        const cell = cells[i];
        if (columns && columns[i]) {
          set(editKey, columns[i].dtoPath || columns[i].key || '', cell.cellState.value !== undefined ? cell.cellState.value : '');
        }
      }
    }

    return editKey;
  }

  private getTemplateUrl(tableAction: DisguiseDto.DTIconUrlTableDto) {
    let result = '';
    if (tableAction.actionConfiguration
        && tableAction.actionConfiguration['@type'] === 'DTFormDialogActionConfiguration') {
      const actionConfiguration = tableAction.actionConfiguration as
          DisguiseDto.DTFormDialogActionConfiguration;
      result = actionConfiguration.formularUrl || '';
    } else if (tableAction.urlBase) {
      result = tableAction.urlBase || '';
    } else {
      result = this.input.formularUrl || '';
    }
    return result;
  }

  private getEntityUrl(tableAction: DisguiseDto.DTIconUrlTableDto) {
    let result = '';
    if (tableAction.actionConfiguration
        && tableAction.actionConfiguration['@type'] === 'DTFormDialogActionConfiguration') {
      const actionConfiguration = tableAction.actionConfiguration as
          DisguiseDto.DTFormDialogActionConfiguration;
      result = actionConfiguration.entityUrl || '';
    } else if (this.input.entityUrl) {
      result = this.input.entityUrl;
    }
    return result;
  }

  private triggerActionWithConfiguration(
      origAction: DisguiseDto.DTIconBaseDto,
      item?: DisguiseDto.DTRowDto
  ) {
    let action: DisguiseDto.DTIconBaseDto;
    if (origAction.actionConfiguration && origAction.actionConfiguration.referenceId && this.actionConfigModifyStore[origAction.actionConfiguration.referenceId]) {
      // merge action config with local modification
      action = {
        ...origAction,
        actionConfiguration: {
          ...origAction.actionConfiguration,
          ...this.actionConfigModifyStore[origAction.actionConfiguration.referenceId]
        },
      };
    } else {
      action = origAction;
    }

    if (action.actionConfiguration && action.actionConfiguration['@type'] === 'DTFormDialogActionConfiguration') {
      this.dialog = {
        content: {
          ['@type']: 'FORMULAR',
          create: action.actionConfiguration.create || false,
          templateUrl: action.actionConfiguration.formularUrl || '',
          formTitle: action.actionConfiguration.dialogTitle || '',
          entityUrl: action.actionConfiguration.entityUrl || '',
          primaryKey: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
          overwrittenFields: action.actionConfiguration.overwrittenFields,
          onClose: () => {
            this.closeDialog();
            if (action.actionConfiguration?.events) {
              for (const currentEvent of action.actionConfiguration.events || []) {
                if (currentEvent.type === 'CloseAfterCloseDTEventDto') {
                  this.$emit('close');
                }
                if (currentEvent.type === 'ReloadAfterCloseDTEventDto') {
                  this.loadData();
                }
                if (currentEvent.type === 'DTOpenSubMenuAfterEvent') {
                  this.subMenu = {
                    url: currentEvent.subMenuUrl || '',
                    contextParameter: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
                    title: '',
                    breadcrumbs: [],
                    actionConfiguration: action.actionConfiguration
                  };
                }
                this.triggerFormularDialogEvent(currentEvent, 'CLOSE');
              }
            }
          },
          onSave: (inlineFormularConfig: FormularConfig, eventData: any) => {
            if (action.actionConfiguration?.events) {
              for (const currentEvent of action.actionConfiguration.events || []) {
                if (currentEvent.type === 'OpenFormularAfterSaveDTEvent') {
                  this.loadData();
                  if (eventData) {
                    this.inlineFormularConfig = {
                      ['@type']: 'FORMULAR',
                      create: false,
                      entityUrl: this.input.entityUrl || '',
                      formTitle: currentEvent.title || '',
                      primaryKey: eventData,
                      onSave: () => {
                        if (!currentEvent.actionConfiguration ||
                            currentEvent.actionConfiguration['@type'] !==
                            'DTNOOPActionConfiguration') {
                          this.closeInlineFormularAndReload();
                        }
                      },
                      onClose: (formConfig: FormularConfig,
                                closeEventData?: FormularCloseEventData) => {
                        if (closeEventData && closeEventData.forceReload) {
                          this.closeInlineFormularAndReload();
                        } else {
                          this.closeInlineFormular();
                        }
                      },
                      templateUrl: currentEvent.formularUrl || ''
                    };
                    this.showInlineFormular = true;
                  }
                  this.showDialog = false;
                  this.dialog = null;
                } else if (currentEvent.type === 'OpenSubmenuAfterSaveDTEvent') {
                  const castedEvent = currentEvent as DisguiseDto.OpenSubmenuAfterSaveDTEventDto;
                  this.loadData();
                  if (eventData) {
                    this.subMenu = {
                      url: castedEvent.subNaviUrl || '',
                      contextParameter: eventData,
                      title: castedEvent.title || '',
                      breadcrumbs: [],
                    };
                  }
                  this.showDialog = false;
                  this.dialog = null;
                } else if (currentEvent.type === 'CloseAndReloadAfterSaveDTEvent') {
                  this.closeDialogAndReload();
                } else if (currentEvent.type === 'CloseAfterSaveDTEvent') {
                  this.closeDialog();
                } else if (currentEvent.type === 'SaveAfterSaveDTEvent') {
                  this.$emit('save', eventData);
                } else if (currentEvent.type === 'DTOverrideActionConfigAfterSave') {
                  if (currentEvent.overrideAction && currentEvent.referenceId) {
                    if (currentEvent.overrideAction.type === 'DTOverrideDTFormDialogActionConfiguration') {
                      if (currentEvent.overrideAction.modifyOverwrittenFieldsBySaveResponse) {
                        const overwrittenFields: {
                          [fieldName: string]: DisguiseDto.FTFieldDto
                        } = {};
                        for (const currentFieldName of Object.keys(currentEvent.overrideAction.modifyOverwrittenFieldsBySaveResponse)) {
                          const fieldName = currentEvent.overrideAction.modifyOverwrittenFieldsBySaveResponse[currentFieldName];
                          overwrittenFields[fieldName] = {
                            type: 'FTFieldDto',
                            value: get(eventData, currentFieldName)
                          };
                        }
                        this.actionConfigModifyStore[currentEvent.referenceId] = {
                          overwrittenFields
                        };
                      }
                    }
                  } else {
                    throw new Error('unexpected configuration');
                  }
                }
                this.triggerFormularDialogEvent(currentEvent, 'SAVE');
                if (currentEvent.optionalUserMessage) {
                  this.$store.commit('showSnack', {
                    message: currentEvent.optionalUserMessage.text,
                    color: 'success'
                  });
                }
              }
            } else {
              this.closeInlineFormularAndReload();
            }

            if (eventData && eventData.actionType['@type'] === 'FormularDialogRedirectActionType') {
              const castedEvent = eventData.actionType as DisguiseDto.FormularDialogRedirectActionType;
              this.dialog = {
                dialogTitle: castedEvent.dialogTitle || '',
                widthPercentage: castedEvent.widthPercentage,
                maxWidthInPx: castedEvent.maxWidthInPx,
                content: {
                  ['@type']: 'FORMULAR',
                  onClose: () => {
                    this.closeDialog();
                  },
                  onSave: () => undefined,
                  templateUrl: castedEvent.formularUrl || '',
                  entityUrl: castedEvent.entityUrl || '',
                  primaryKey: {},
                  formTitle: castedEvent.dialogTitle || '',
                  create: castedEvent.create
                }
              };
              this.showDialog = true;
            }
          }
        },
        widthPercentage: action.actionConfiguration.widthPercentage,
        maxWidthInPx: action.actionConfiguration.maxWidthInPx,
        dialogTitle: action.actionConfiguration.dialogTitle || '',
        maxHeightByViewPortDiffInPx: action.actionConfiguration.maxHeightByViewPortDiffInPx,
      };
      this.showDialog = true;
      this.$set(action, 'loading', false);
    } else if (action.actionConfiguration
        && action.actionConfiguration['@type'] === 'DTCallAPIAfterSelectConfiguration') {
      if (item) {
        const postUrl = action.actionConfiguration.endpointUrl || '';
        const params: CompositeKeyType =
            this.getPrimaryKeyForRowItem(
                item,
                this.input.columns || [],
                action.urlParameters,
                true
            );
        const successEventName = action.actionConfiguration.successEventName;
        HTTP_SERVICE_INSTANCE.getAxios().post(postUrl, params).then((response) => {
          this.$set(action, 'loading', false);

          if (successEventName) {
            this.$emit(successEventName, response.data);
          }
        }, () => {
          this.$set(action, 'loading', false);
        });
      }
    } else if (action.actionConfiguration && action.actionConfiguration['@type'] === 'DTOpenHrefConfiguration') {
      this.openHrefConfiguration(action, item);
    } else if (action.actionConfiguration
        && action.actionConfiguration['@type'] === 'DTOpenSubMenuConfiguration') {
      this.subMenu = {
        url: action.urlBase || '',
        contextParameter: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
        title: action.title || '',
        breadcrumbs: [],
        actionConfiguration: action.actionConfiguration
      };
      this.$set(action, 'loading', false);
    } else if (action.actionConfiguration
        && action.actionConfiguration['@type'] === 'DTSelectConfiguration') {
      if (item) {
        const selectIcon = this.findSelectIconInRow(item);
        if (selectIcon) {
          const url = this.buildRestURL(
              undefined,
              selectIcon.urlBase || '',
              item,
              false
          );
          this.$emit('selected', {params: selectIcon.urlParameters, url, baseUrl: selectIcon.urlBase});

          const castedConfig = action.actionConfiguration as DisguiseDto.DTSelectConfiguration;
          if (castedConfig.events) {
            this.executeActionConfigEvents(castedConfig.events);
          }
        }
        this.$set(action, 'loading', false);
      }
    } else if (action.actionConfiguration && action.actionConfiguration['@type'] === 'DTBreadCrumbConfiguration') {
      if (action.actionConfiguration.naviTypes) {
        const key = AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters);
        const disguiseRoutes: DisguiseRoute[] = [];

        for (const currentNaviType of action.actionConfiguration.naviTypes) {
          disguiseRoutes.push(NAVI_SERVICE_INSTANCE.convertNaviType(
              currentNaviType,
              key,
              0,
          ));
        }

        const breadcrumbEventData: BreadCrumbConfig = {
          text: action.actionConfiguration.title || '',
          routes: disguiseRoutes
        };

        this.$emit('on-new-breadcrumb-pushed', breadcrumbEventData);
        this.$set(action, 'loading', false);
      }
    } else if (action.actionConfiguration && action.actionConfiguration['@type'] === 'DTOpenInlineFormActionConfiguration') {
      const castedActionConfiguration = action.actionConfiguration as DisguiseDto.DTOpenInlineFormActionConfiguration;
      this.inlineFormularConfig = {
        ['@type']: 'FORMULAR',
        create: action.actionConfiguration.create || false,
        entityUrl: action.actionConfiguration.entityUrl || '',
        formTitle: action.actionConfiguration.formularTitle || '',
        primaryKey: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
        onSave: () => {
          for (const currentOnSaveEvent of castedActionConfiguration.onSaveEvents || []) {
            if (currentOnSaveEvent.type === 'CloseInlineFormularDTEvent') {
              const castedCloseInlineFormularEvent = currentOnSaveEvent as DisguiseDto.CloseInlineFormularDTEventDto;
              if (castedCloseInlineFormularEvent.reload !== undefined && castedCloseInlineFormularEvent.reload) {
                this.inlineFormularConfig = null;
                this.closeInlineFormularAndReload();
              }
            }
          }
        },
        onClose: () => {
          if (action.actionConfiguration?.events) {
            for (const currentEvent of action.actionConfiguration.events || []) {
              if (currentEvent.type === 'ReloadAfterCloseDTEventDto') {
                this.loadData();
              }
            }
          }
          if (castedActionConfiguration.onCloseEvents) {
            for (const currentOnCloseEvent of castedActionConfiguration.onCloseEvents) {
              if (currentOnCloseEvent.type === 'CloseInlineFormularDTEvent') {
                const castedCloseInlineFormularEvent = currentOnCloseEvent as DisguiseDto.CloseInlineFormularDTEventDto;
                if (castedCloseInlineFormularEvent.reload !== undefined && castedCloseInlineFormularEvent.reload) {
                  this.inlineFormularConfig = null;
                  this.closeInlineFormularAndReload();
                } else {
                  this.inlineFormularConfig = null;
                  this.closeInlineFormular();
                }
              }
            }
          } else {
            this.inlineFormularConfig = null;
            this.closeInlineFormular();
          }
        },
        templateUrl: action.actionConfiguration.formularUrl || ''
      };
      this.showInlineFormular = true;
      this.$set(action, 'loading', false);
    } else {
      this.$set(action, 'loading', false);
      throw new Error('Unsupported action configuration type');
    }
  }

  private triggerFormularDialogEvent(
      eventCfg: DisguiseDto.DTEventDto,
      dialogEvent: DisguiseDto.DialogParameterEventTypeEnum
  ) {
    if (eventCfg.type === 'DTExecuteEventAfterDialogEvent') {
      const castedCurrentEvent = eventCfg as DisguiseDto.DTExecuteEventAfterDialogEvent;
      if (castedCurrentEvent.dialogEvent === dialogEvent) {
        const castedCurrentEventInner = castedCurrentEvent.event;
        if (castedCurrentEventInner) {
          switch (castedCurrentEventInner.type) {
            case 'DTPropagateGlobalEventDto': {
              const propagateGlobalEvent =
                  castedCurrentEventInner as DisguiseDto.DTPropagateGlobalEventDto;
              DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE.propagateGlobalEvent(propagateGlobalEvent);
              break;
            }
            default: {
              break;
            }
          }
        }
      }
    }
  }

  private executeDialogCtrl(rowClickEvent: Event,
                            action: DisguiseDto.DTIconUrlRowDto,
                            props: DataTableItemProps,
                            additionalUrlParams?: { [key: string]: string }) {
    const actionUrlParams = {};
    for (const currentActionParameter of action.urlParameters || []) {
      set(actionUrlParams, currentActionParameter.parameter || '', currentActionParameter.value);
    }
    const actionUrlBase = action.urlBase || '';

    let sendUrl: string;
    const urlParams = URL_SERVICE_INSTANCE.serialize({
      ...actionUrlParams,
      ...(additionalUrlParams ? additionalUrlParams : {})
    });
    if (urlParams) {
      sendUrl = actionUrlBase
          + (actionUrlBase.indexOf('?') > -1 ? '&' : '?')
          + urlParams;
    } else {
      sendUrl = actionUrlBase;
    }

    const urlParameter = this.getPrimaryKeyForRowItem(
        props.item,
        this.input.columns || [],
        action.urlParameters
    );

    HTTP_SERVICE_INSTANCE.getAxios().post(sendUrl, urlParameter).then((response) => {
      if (response.status < 400) {
        if (!response.data.done) {
          switch (response.data.dialogType) {
            case 'PROMT_DIALOG':
              (this.$refs.promt as any).open('Achtung',
                  response.data.dialogMessage).then(
                  (input: string) => {
                    const configuredId = response.data.dialogConfirmedId;

                    this.executeDialogCtrl(rowClickEvent, action, props, {
                      ...(input ? {promtInput: input} : {}),
                      ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                    });
                  });
              break;
            case 'ALERT_DIALOG':
              (this.$refs.alert as any).open('Achtung',
                  [response.data.dialogMessage]).then(() => {
                const configuredId = response.data.dialogConfirmedId;
                this.executeDialogCtrl(rowClickEvent, action, props, {
                  ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                });
              });
              break;
            case 'CONFIRM_DIALOG':
              this.confirmationDialogConfig = {
                title: 'Bestätigen',
                headerColor: 'primary',
                message: response.data.dialogMessage || '',
                closeButton: {
                  onClick: () => {
                    this.$set(action, 'loading', false);
                    this.confirmationDialogConfig = null;
                  }
                },
                buttons: [{
                  text: response.data.confirmButtonTitle || 'Bestätigen',
                  title: response.data.confirmButtonTitle || 'Bestätigen',
                  disabled: false,
                  loading: false,
                  autoFocus: true,
                  onClick: () => {
                    const configuredId = response.data.dialogConfirmedId;
                    this.executeDialogCtrl(rowClickEvent, action, props, {
                      ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                    });
                    this.confirmationDialogConfig = null;
                  }
                }, {
                  text: response.data.abortButtonTitle || 'Abbrechen',
                  title: response.data.abortButtonTitle || 'Abbrechen',
                  disabled: false,
                  loading: false,
                  onClick: () => {
                    const configuredId = response.data.dialogAbortId;
                    this.executeDialogCtrl(rowClickEvent, action, props, {
                      ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                    });
                    this.confirmationDialogConfig = null;
                  }
                }],
                onEsc: () => {
                  this.$set(action, 'loading', false);
                  this.confirmationDialogConfig = null;
                }
              };
              break;
            default:
              break;
          }
        } else {
          // response.data.done is true. execute events if there are any
          const actionConfiguration = action.actionConfiguration;
          if (actionConfiguration && actionConfiguration.events) {
            for (const currentEvent of actionConfiguration.events) {
              if (currentEvent.type === 'DTPropagateGlobalEventDto') {
                DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE.propagateGlobalEvent(currentEvent);
              }
            }
          }
          this.$set(action, 'loading', false);
        }
        if (response.data.success) {
          if (response.data.closeAfterSuccess) {
            this.loadData();
          }
          if (response.data.reloadParentForm) {
            this.updateParent();
          }
          this.handleConfirmButtonResponse(response);
          this.$set(action, 'loading', false);
        }
      } else {
        this.handleConfirmButtonResponse(response);
        this.$set(action, 'loading', false);
      }
    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: 'Operation fehlgeschlagen',
          color: 'error'
        });
      }
      this.$set(action, 'loading', false);
    });
  }

  private openHrefConfiguration(
      action: DisguiseDto.DTIconUrlRowDto,
      item?: DisguiseDto.DTRowDto
  ) {
    this.$set(action, 'loading', false);
    const castedActionConfiguration = action.actionConfiguration as DisguiseDto.DTOpenHrefConfiguration;

    let hrefWithParams = '';
    if (item) {
      hrefWithParams = this.buildRestURL(
          action.urlParameters || [],
          castedActionConfiguration.href || '',
          item,
          false
      );
    } else {
      hrefWithParams = castedActionConfiguration.href || '';
    }

    if (castedActionConfiguration.target) {
      let target: string = '_self';
      switch (castedActionConfiguration.target) {
        case 'BLANK':
          target = '_blank';
          break;
        default:
          target = '_self';
          break;
      }

      window.open(hrefWithParams, target);
    } else {
      window.open(hrefWithParams);
    }
  }

  private unregisterAllGlobalEventListeners() {
    if (this.registeredGlobalEventListenerNames) {
      for (const currentGlobalEventListenerName of this.registeredGlobalEventListenerNames) {
        GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.detachListener(currentGlobalEventListenerName, this.globalEventListenerTriggeredCb);
      }
    }
  }

  private globalEventListenerTriggeredCb(eventData: any) {
    if (eventData) {
      const eventType = eventData['@type'];
      if (eventType) {
        switch (eventType) {
          case 'DTReloadEventActionDto': {
            if (eventData.optionalUserMessage) {
              this.$store.commit('showSnack', {
                message: eventData.optionalUserMessage.text,
                color: 'success'
              });
            }

            if (this.confirmationDialogConfig) {
              this.confirmationDialogConfig = null;
            }

            this.loadData();
            break;
          }
          case 'DTUpdateFilterParamActionDto': {
            const data = eventData as DisguiseDto.DTUpdateFilterParamActionDto;
            if (data.params) {
              const copyOfCurrentConfiguration = cloneDeep(this.inputConfiguration);
              for (const param of data.params) {
                let filterPresent = false;
                for (const currentColumnFilter of copyOfCurrentConfiguration.filterColumns || []) {
                  if (currentColumnFilter.key === param.parameter) {
                    currentColumnFilter.searchValue = param.value;
                    filterPresent = true;
                  }
                }
                if (!filterPresent) {
                  if (copyOfCurrentConfiguration.filterColumns === undefined) {
                    copyOfCurrentConfiguration.filterColumns = [];
                  }
                  copyOfCurrentConfiguration.filterColumns.push({
                    searchValue: param.value,
                    key: param.parameter
                  } as DisguiseDto.DTInputColumnDto);
                }
              }
              this.inputConfiguration = copyOfCurrentConfiguration; // write them only once
            }
          }
          case 'DTRemoveElementActionDto': {
            const data = eventData as DisguiseDto.DTRemoveElementActionDto;

            const filteredResultsByPrimaryKey = filter(this.input.rows, matchesProperty('primaryKey', data.rowKey));
            if (filteredResultsByPrimaryKey && filteredResultsByPrimaryKey.length === 1) {
              const itemFound = filteredResultsByPrimaryKey[0];
              const itemIdx = (this.input.rows || []).indexOf(itemFound);
              (this.input.rows || []).splice(itemIdx, 1);
            }
            break;
          }
          case 'DTEmitEventAction': {
            const eventAction = eventData as DisguiseDto.DTEmitEventActionDto;
            this.$emit(eventAction.eventName || '', eventAction);
            break;
          }
          default: {
            break;
          }
        }
      }
    }
  }

  private registerGlobalEventListener(currentGlobalEventListenerName: string) {
    GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.registerListener(currentGlobalEventListenerName, this.globalEventListenerTriggeredCb);
    this.registeredGlobalEventListenerNames.push(currentGlobalEventListenerName);
  }

  private getTemplateUrlHtmlNameAttributeCapable() {
    return `${(this.templateUrl || '').replace(/[^a-zA-Z.0-9]/g, '-')}-fulltextsearch`;
  }

  private executeActionConfigEvents(events: DTEventDtoUnion[]) {
    for (const event of (events || [])) {
      if (event.type === 'DTPropagateGlobalEventDto') {
        const globalEventDto = event as DisguiseDto.DTPropagateGlobalEventDto;
        GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.notifyListener(globalEventDto.event || '', globalEventDto.globalEventAction);
      }
    }
  }
}
